import {
  call,
  put,
  takeLatest,
  select,
  debounce,
  all,
  takeEvery,
} from 'redux-saga/effects';

import Const, { ADD_REPORT_EVENT_STEP_MAP } from 'constant/Const';
import {
  ECG_CHART_UNIT,
  SELECTION_MARKER_TYPE,
  TEN_SEC_SCRIPT_DETAIL,
  TEN_SEC_STRIP,
  TEN_SEC_STRIP_DETAIL,
  TEN_SEC_STRIP_EDIT,
} from 'constant/ChartEditConst';
import {
  EVENT_CONST_TYPES,
  EVENT_GROUP_TYPE,
  BEAT_TYPE,
  TIME_EVENT_TYPE,
  REPORT_TYPE,
  REPORT_SECTION,
} from 'constant/EventConst';
import { INFINITY_SCROLL } from 'constant/InfinityScrollConst';

import ApiManager from 'network/ApiManager';
import DateUtil from 'util/DateUtil';
import {
  transformRawList,
  transformEctopicWithBeats,
  transformTimeEvents,
  mergeBeatEventInfoMap,
  getInitRepresentativeStripInfo,
  getSearchBeatsNEctopicListRangeAfterUpdateEvent,
  _getTenSecStripInfo,
  _getFilterBeatsNEctopicList,
  _getHrAvg,
  mergeLeadOffInfo,
} from 'util/TestResultDuckUtil';
import {
  getEventInfoByQuery,
  getEventInfoByType,
  getSidePanelEventData,
} from 'util/EventConstUtil';
// 😱😱😱
import ChartUtil from 'util/ChartUtil';
// 😱😱😱

// Selector
// Actions
// etc function
// Reducer
// Action Creators
// Saga functions
// Saga
const DEBUGGING_LOG_ECG_RAW = 0;

// Selector
const selectEcgTestId = (state) => state.testResultReducer.ecgTestId;
export const selectReportId = (state) =>
  state.testResultReducer.ecgTest.data.latestRid;
export const selectRecordingTime = (state) =>
  state.testResultReducer.recordingTime;
export const selectSideTabValue = ({ testResultReducer: state }) =>
  state.eventReview.sidePanelState.tabValue;
const getRawDataOnly = (state) =>
  state.testResultReducer.ecgTest.data.isRawDataOnly;
const getTestVersion = (state) =>
  state.testResultReducer.ecgTest.data.testVersion;
const getEcgRawList = (state) => state.testResultReducer.ecgRaw.ecgRawList;
const getTenSecStrip = (state) =>
  state.testResultReducer.eventReview.tenSecStrip;
const selectBeatsNEctopicList = (state) =>
  state.testResultReducer.beatsNEctopicList.data;
/** 리포트 담기 중 대표 Strip 선택 가능 상황 */
export const selectIsSelectableRepresentativeStrip = ({
  testResultReducer: state,
}) =>
  ![null, REPORT_TYPE.ADDITIONAL].includes(
    state.eventReview.addReport.selectedReportSection
  ) && state.eventReview.addReport.addStep === ADD_REPORT_EVENT_STEP_MAP.TITLE;
/** Events 텝에서 전체 이벤트 조회 가능 상황 */
export const selectIsSelectableChart = ({ testResultReducer: state }) =>
  state.eventReview.sidePanelState.tabValue === EVENT_GROUP_TYPE.EVENTS &&
  state.eventReview.addReport.addStep === ADD_REPORT_EVENT_STEP_MAP.CANCEL;

// Actions
// Global State Actions
const INITIALIZE = 'memo-web/test-result/INITIALIZE';
// EntireEcgFragment Data
const SET_NAVIGATOR_TIMESTAMP =
  'memo-web/test-result/event/SET_NAVIGATOR_TIMESTAMP';
const SET_HR_HIGHLIGHT_TIMESTAMP =
  'memo-web/test-result/event/SET_HR_HIGHLIGHT';
// Manage Side Panel State
const SET_SIDE_PANEL_TAB_VALUE =
  'memo-web/test-result/event/SET_SIDE_PANEL_TAB_VALUE';
const SET_SIDE_PANEL_SELECTED_VALUE_LIST =
  'memo-web/test-result/event/SET_SIDE_PANEL_SELECTED_VALUE_LIST';
// Representative Strip State Management
const SET_REPRESENTATIVE_STRIP_INFO =
  'memo-web/test-result/event/SET_REPRESENTATIVE_STRIP_INFO';
const RESET_REPRESENTATIVE_STRIP_INFO =
  'memo-web/test-result/event/RESET_REPRESENTATIVE_STRIP_INFO';
const SET_CHART_SELECTED_STRIP =
  'memo-web/test-result/SET_CHART_SELECTED_STRIP';
// Add Report Management
const SET_ADD_REPORT_EVENT_START =
  'memo-web/test-result/SET_ADD_REPORT_EVENT_START';
const SET_ADD_REPORT_EVENT_CLOSE =
  'memo-web/test-result/SET_ADD_REPORT_EVENT_CLOSE';
const ADJUST_ADD_REPORT_EVENT_NEW_STATE =
  'memo-web/test-result/ADJUST_ADD_REPORT_EVENT_NEW_STATE';
// Update ECG Test Info. in Global State
const UPDATE_ECG_TEST_INFO = 'memo-web/test-result/UPDATE_ECG_TEST_INFO';
const SET_BASIC_LEAD_OFF = 'memo-web/test-result/SET_BASIC_LEAD_OFF';

// Server State Actions
// Get ECG Test
const GET_ECG_TEST_REQUESTED = 'memo-web/test-result/GET_ECG_TEST_REQUESTED';
const GET_ECG_TEST_SUCCEED = 'memo-web/test-result/GET_ECG_TEST_SUCCEED';
const GET_ECG_TEST_FAILED = 'memo-web/test-result/GET_ECG_TEST_FAILED';
// Get single events
const GET_EVENT_DETAIL_REQUESTED =
  'memo-web/test-result/GET_EVENTS_DETAIL_REQUESTED';
const GET_EVENT_DETAIL_SUCCEED =
  'memo-web/test-result/GET_EVENTS_DETAIL_SUCCEED';
const GET_EVENT_DETAIL_FAILED = 'memo-web/test-result/GET_EVENTS_DETAIL_FAILED';
// Get & Post & Delete & Update report events
const GET_REPORT_EVENTS_REQUESTED =
  'memo-web/test-result/GET_REPORT_EVENTS_REQUESTED';
const GET_REPORT_EVENTS_SUCCEED =
  'memo-web/test-result/GET_REPORT_EVENTS_SUCCEED';
const GET_REPORT_EVENTS_FAILED =
  'memo-web/test-result/GET_REPORT_EVENTS_FAILED';
const POST_REPORT_EVENT_REQUESTED =
  'memo-web/test-result/POST_REPORT_EVENT_REQUESTED';
const POST_REPORT_EVENT_SUCCEED =
  'memo-web/test-result/POST_REPORT_EVENT_SUCCEED';
const POST_REPORT_EVENT_FAILED =
  'memo-web/test-result/POST_REPORT_EVENT_FAILED';
const UPDATE_REPORT_EVENT_REQUESTED =
  'memo-web/test-result/UPDATE_REPORT_EVENT_REQUESTED';
const UPDATE_REPORT_EVENT_SUCCEED =
  'memo-web/test-result/UPDATE_REPORT_EVENT_SUCCEED';
const UPDATE_REPORT_EVENT_FAILED =
  'memo-web/test-result/UPDATE_REPORT_EVENT_FAILED';
const DELETE_REPORT_EVENT_REQUESTED =
  'memo-web/test-result/DELETE_REPORT_EVENT_REQUESTED';
const DELETE_REPORT_EVENT_SUCCEED =
  'memo-web/test-result/DELETE_REPORT_EVENT_SUCCEED';
const DELETE_REPORT_EVENT_FAILED =
  'memo-web/test-result/DELETE_REPORT_EVENT_FAILED';

// GET ECG Statistics data
const GET_ECGS_STATISTICS_REQUESTED =
  'memo-web/test-result/GET_ECGS_STATISTICS_REQUESTED';
const GET_ECGS_STATISTICS_SUCCEED =
  'memo-web/test-result/GET_ECGS_STATISTICS_SUCCEED';
const GET_ECGS_STATISTICS_FAILED =
  'memo-web/test-result/GET_ECGS_STATISTICS_FAILED';

// GET Report Statistics data
const GET_REPORTS_STATISTICS_REQUESTED =
  'memo-web/test-result/GET_REPORTS_STATISTICS_REQUESTED';
const GET_REPORTS_STATISTICS_SUCCEED =
  'memo-web/test-result/GET_REPORTS_STATISTICS_SUCCEED';
const GET_REPORTS_STATISTICS_FAILED =
  'memo-web/test-result/GET_REPORTS_STATISTICS_FAILED';

// Get All Statistics data
const GET_ALL_STATISTICS_REQUESTED =
  'memo-web/test-result/GET_ALL_STATISTICS_REQUESTED';
const GET_ALL_STATISTICS_SUCCEED =
  'memo-web/test-result/GET_ALL_STATISTICS_SUCCEED';
const GET_ALL_STATISTICS_FAILED =
  'memo-web/test-result/GET_ALL_STATISTICS_FAILED';

// Adjust Statistics Count
const ADJUST_ECGS_STATISTICS = 'memo-web/test-result/ADJUST_ECGS_STATISTICS';
const ADJUST_REPORTS_STATISTICS =
  'memo-web/test-result/ADJUST_REPORTS_STATISTICS';

// Get entire events
const GET_TIME_EVENTS_LIST_REQUESTED =
  'memo-web/test-result/GET_TIME_EVENTS_LIST_REQUESTED';
const GET_TIME_EVENTS_LIST_SUCCEED =
  'memo-web/test-result/GET_TIME_EVENTS_LIST_SUCCEED';
const GET_TIME_EVENTS_LIST_FAILED =
  'memo-web/test-result/GET_TIME_EVENTS_LIST_FAILED';
const GET_BEATS_N_ECTOPIC_LIST_REQUESTED =
  'memo-web/test-result/GET_BEATS_N_ECTOPIC_LIST_REQUESTED';
const GET_BEATS_N_ECTOPIC_LIST_SUCCEED =
  'memo-web/test-result/GET_BEATS_N_ECTOPIC_LIST_SUCCEED';
const GET_BEATS_N_ECTOPIC_LIST_FAILED =
  'memo-web/test-result/GET_BEATS_N_ECTOPIC_LIST_FAILED';

// Get daily heart rate
const GET_DAILY_HEART_RATE_REQUESTED =
  'memo-web/test-result/GET_DAILY_HEART_RATE_REQUESTED';
const GET_DAILY_HEART_RATE_SUCCEED =
  'memo-web/test-result/GET_DAILY_HEART_RATE_SUCCEED';
const GET_DAILY_HEART_RATE_FAILED =
  'memo-web/test-result/GET_DAILY_HEART_RATE_FAILED';

// Get ecgRaw data
const GET_ECGRAW_INIT_REQUESTED =
  'memo-web/test-result/GET_ECGRAW_INIT_REQUESTED';
const GET_ECGRAW_BACKWARD_REQUESTED =
  'memo-web/test-result/GET_ECGRAW_BACKWARD_REQUESTED';
const GET_ECGRAW_FORWARD_REQUESTED =
  'memo-web/test-result/GET_ECGRAW_FORWARD_REQUESTED';
const GET_ECGRAW_REQUESTED = 'memo-web/test-result/GET_ECGRAW_REQUESTED';
const GET_ECGRAW_INIT_SUCCEED = 'memo-web/test-result/GET_ECGRAW_INIT_SUCCEED';
const GET_ECGRAW_SUCCEED = 'memo-web/test-result/GET_ECGRAW_SUCCEED';
const GET_ECGRAW_FAILED = 'memo-web/test-result/GET_ECGRAW_FAILED';

// Arrhythmia Edit
const SET_SELECTION_STRIP = 'memo-web/test-result/SET_SELECTION_STRIP';
const SET_TENSEC_STRIP = 'memo-web/test-result/SET_TENSEC_STRIP';
const SET_TENSEC_STRIP_DETAIL = 'memo-web/test-result/SET_TENSEC_STRIP_DETAIL';
const SET_ARRHYTHMIA_CONTEXTMENU =
  'memo-web/test-result/SET_ARRHYTHMIA_CONTEXTMENU';
const SET_BEAT_CONTEXTMENU = 'memo-web/test-result/SET_BEAT_CONTEXTMENU';
// set 10sec beat strip btn data

// ECG chart list - setting
const SET_ECGCHARTLIST_SCROLL_TOP =
  'memo-web/test-result/SET_ECGCHARTLIST_SCROLL_TOP';
const SET_IS_ECGCHARTLIST_SCROLL_TO_INDEX =
  'memo-web/test-result/SET_IS_ECGCHARTLIST_SCROLL_TO_INDEX';

// post beats
const POST_BEATS_REQUESTED = 'memo-web/patch-ecgs/POST_BEATS_REQUESTED';
const POST_BEATS_SUCCEED = 'memo-web/patch-ecgs/POST_BEATS_SUCCEED';
const POST_BEATS_FAILED = 'memo-web/patch-ecgs/POST_BEATS_FAILED';

// patch beats
const PATCH_BEATS_REQUESTED = 'memo-web/patch-ecgs/PATCH_BEATS_REQUESTED';
const PATCH_BEATS_SUCCEED = 'memo-web/patch-ecgs/PATCH_BEATS_SUCCEED';
const PATCH_BEATS_FAILED = 'memo-web/patch-ecgs/PATCH_BEATS_FAILED';

// delete beats
const DELETE_BEATS_REQUESTED = 'memo-web/patch-ecgs/DELETE_BEATS_REQUESTED';
const DELETE_BEATS_SUCCEED = 'memo-web/patch-ecgs/DELETE_BEATS_SUCCEED';
const DELETE_BEATS_FAILED = 'memo-web/patch-ecgs/DELETE_BEATS_FAILED';

// post time events
const POST_TIME_EVENT_REQUESTED =
  'memo-web/time-event/POST_TIME_EVENT_REQUESTED';
const POST_TIME_EVENT_SUCCEED = 'memo-web/time-event/POST_TIME_EVENT_SUCCEED';
const POST_TIME_EVENT_FAILED = 'memo-web/time-event/POST_TIME_EVENT_FAILED';

// todo: jyoon[221004] action, reducer 순서 맞추기

// Request Print Report
const REQUEST_PRINT_REPORT_REQUESTED =
  'memo-web/test-result/REQUEST_PRINT_REPORT_REQUESTED';
const REQUEST_PRINT_REPORT_SUCCEED =
  'memo-web/test-result/REQUEST_PRINT_REPORT_SUCCEED';
const REQUEST_PRINT_REPORT_FAILED =
  'memo-web/test-result/REQUEST_PRINT_REPORT_FAILED';

// Reducer
const initialState = {
  // View Data
  ecgTestId: null,
  recordingTime: { recordingStartMs: null, recordingEndMs: null },
  general: {},
  eventReview: {
    isSetEcgChartListScroll: false,
    navigatorTimestamp: null, // initValue = recordingTime, 시간이동시 여기에 저장
    hrHighlightTimestamp: null, // hr차트에서 선택한 시간
    ecgCaretTimestamp: null, // 캐럿타임
    /**
     * SidePanel 관련 State
     * tabValue: 선택된 탭 밸류
     * selectedValueList: {type: EVENT_CONST_TYPES, position: Number, timeEventId: Number | null, waveformIndex: Number: null}
     */
    sidePanelState: {
      tabValue: EVENT_GROUP_TYPE.EVENTS,
      selectedValueList: [],
      isUpdateFromChart: false,
    },
    addReport: {
      // 수정용
      reportEventId: null, // 수정이라면 String, 그 외 초기화 시 null
      prevTitle: null, // 수정이라면 String, 그 외 초기화 시 null
      prevRepresentativeInfo: {
        selectedMs: null,
        representativeOnsetIndex: null,
        representativeTerminationIndex: null,
      },
      // 수정, 신규
      eventType: null, // EventConst > EVENT_CONST_TYPES, 초기화 시 null
      addStep: 0, // 0: 리포트 담기 과정 아님, 1: report page 선택 단계, 2: report 타이틀 입력 단계
      selectedReportSection: null, // EventConst > REPORT_SECTION 중 하나, 초기화 시 null
    },
    // 리포트 담기 및 수정 시 초기 10초 스트립 정보
    representativeStripInfo: {
      selectedMs: null,
      representativeOnsetIndex: null,
      representativeTerminationIndex: null,
    },
    tenSecStripDetail: {
      onsetMs: undefined,
      terminationMs: undefined,
      onsetWaveformIdx: undefined,
      terminationWaveformIdx: undefined,
      hrAvg: undefined,
      ecgRaw: undefined,
      beatLabelButtonDataList: undefined,
      pending: false,
      error: null,
    },
    chartSelectedTimestamp: 0,
    // event edit
    selectionStrip: {
      onset: {
        representativeTimestamp: undefined,
        representativeWaveformIndex: undefined,
        clickedWaveformIndex: undefined,
        clickedTimestamp: undefined,
      },
      termination: {
        representativeTimestamp: undefined,
        representativeWaveformIndex: undefined,
        clickedWaveformIndex: undefined,
        clickedTimestamp: undefined,
      },
    },
    tenSecStrip: {
      representativeCenterTimeStamp: undefined,
      representativeCenterWaveformIndex: undefined,
      centerWaveformIndex: undefined,
      main: {
        type: TEN_SEC_STRIP.TYPE.MAIN,
        position: '',
        representativeTimestamp: undefined,
        onsetWaveformIndex: undefined,
        terminationWaveformIndex: undefined,
      },
      extra: {
        type: TEN_SEC_STRIP.TYPE.EXTRA,
        position: '',
        representativeTimestamp: undefined,
        onsetWaveformIndex: undefined,
        terminationWaveformIndex: undefined,
      },
    },
    isOpenArrhythmiaContextmenu: false,
    isOpenBeatContextmenu: false,
    ecgChartListScrollTop: 0,
  },

  // API Data
  ecgTest: {
    pending: false,
    data: null,
    error: null,
  },
  timeEventsList: {
    pending: false,
    error: null,
    leadOff: [],
    data: [
      // {
      //   createAt: 0, // 정보 생성 시각의 timestamp === 부정맥 정보 업데이트 시점
      //   type: '',
      //   onsetMs: 0,
      //   onsetWaveformIndex: 0,
      //   terminationMs: 0,
      //   terminationWaveformIndex: 0,
      //   // 이하 API 조회 시 필요한 정보
      //   timeEventId: '',
      //   onsetRPeakIndex: 0,
      //   position: 0,
      // },
    ],
  },
  beatsNEctopicList: {
    pending: false,
    error: null,
    data: {},
  },
  // 10s strip detail - beat data
  beats: {
    pending: false,
    data: {
      waveformIndex: [],
      beatType: [],
      hr: [],
      bpm: null,
      position: [],
    },
    error: null,
  },
  //  10s strip detail: 선택된 비트 차트 (hr 리뷰 오른쪽 데이터들 idx, 10sec Strip...) Req.3번 방식
  beatsTenSecStripDetail: {
    pending: false,
    data: {
      baselineWaveformIndex: 0,
      ecgData: [],
      beatTypeZones: [],
      beats: {},
      duration: null,
      hrAvg: null,
      hrMax: null,
      hrMin: null,
      onsetMs: null,
      terminationMs: null,
      onsetWaveformIndex: null,
      terminationWaveformIndex: null,
      beatRenderData: null,
      beatBtnRenderData: null,
    },
    error: null,
  },
  hrv: {
    pending: false,
    data: {
      heartRatePoints: [],
      hourlyBands: [],
    },
    error: null,
  },
  /**
   * Patient Triggered Events 목록, HRV 데이터 생성과정 중 함께 생성
   */
  patientEvents: [
    // {
    //   position: 0,
    //   eventTimestamp: 1652353692000,
    //   eventBy: 1,
    //   eventType: 10,
    //   eventEntryType: 1,
    //   eventEtcNote: null,
    //   patientNote: null,
    //   triggerStartTimestamp: 1652353650000,
    //   triggerEndTimestamp: 1652353740000,
    // },
  ],
  // timeEvent, ectopicEvent 를 아우르는 구성으로 변경?
  updateTimeEvent: {
    // time Events api (AF, Pause, Others)
    pending: false,
    data: {},
    error: null,
  },
  ectopicEvent: {
    // ectopic Events api (iso, couplet , VT, VPC, ...)
    // 계산을 클라이언트에서 할지, 서버에서 계산해서 받을지?
    pending: false,
    data: {},
    error: null,
  },
  eventDetail: {
    pending: false,
    data: null,
    error: null,
  },
  reportDetail: {
    pending: false,
    data: null,
    error: null,
  },
  reportEvents: {
    pending: false,
    data: null,
    error: null,
  },
  reportState: {
    pending: false,
    data: null,
    error: null,
  },
  ecgStatistics: {
    pending: false,
    data: null,
    error: null,
  },
  reportStatistics: {
    pending: false,
    data: null,
    error: null,
  },
  allStatistics: {
    pending: false,
    data: null,
    error: null,
  },
  ecgRaw: {
    // pending
    pending: [],
    backwardPending: false,
    forwardPending: false,

    // direction
    isBackward: false,
    isForward: false,

    // data list
    ecgRawList: [],
    ecgRawSection: {
      beginOnset: undefined,
      endTermination: undefined,
    },
    initExtraSelection: {
      backward: { onset: undefined, termination: undefined },
      forward: { onset: undefined, termination: undefined },
    },

    // option
    isJumpToTime: undefined,
    navigatorTime: undefined,
    caretTime: undefined,
    scrollType: undefined,
    prependDataLength: undefined,
    withBeat: undefined,
    isBeatStrip: undefined,
    error: null,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case INITIALIZE:
      if (action.targetSection) {
        return {
          ...state,
          [action.targetSection]: initialState[action.targetSection],
        };
      } else {
        return {
          ...initialState,
          ecgTestId: action.ecgTestId,
        };
      }
    // EntireEcgFragment Data
    case SET_NAVIGATOR_TIMESTAMP:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          navigatorTimestamp: action.timestamp,
          ecgCaretTimestamp: action.timestamp,
          isSetEcgChartListScroll: false,
        },
      };
    case SET_HR_HIGHLIGHT_TIMESTAMP:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          hrHighlightTimestamp: action.timestamp,
          ecgCaretTimestamp: action.timestamp,
          isSetEcgChartListScroll: false,
        },
      };
    // Handle SidePanel State
    case SET_SIDE_PANEL_TAB_VALUE:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          sidePanelState: {
            ...initialState.eventReview.sidePanelState,
            tabValue: action.tabValue,
          },
          tenSecStrip: {
            ...initialState.eventReview.tenSecStrip,
          },
        },
        eventDetail: {
          ...initialState.eventDetail,
        },
        reportDetail: {
          ...initialState.reportDetail,
        },
      };
    case SET_SIDE_PANEL_SELECTED_VALUE_LIST:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          sidePanelState: {
            ...state.eventReview.sidePanelState,
            selectedValueList: action.newSelectedValueList,
            isUpdateFromChart: action.isFromChart,
          },
        },
      };
    // Representative Strip State Management
    case SET_REPRESENTATIVE_STRIP_INFO:
      let { representativeOnsetIndex, representativeTerminationIndex } =
        action.newInfo;
      const representativeStripLength =
        representativeTerminationIndex - representativeOnsetIndex;
      const lastWaveformIndex = Math.floor(
        (state.recordingTime.recordingEndMs -
          state.recordingTime.recordingStartMs) /
          4
      );
      if (representativeOnsetIndex < 0) {
        representativeOnsetIndex = 1;
        representativeTerminationIndex = representativeStripLength + 1;
      } else if (lastWaveformIndex < representativeTerminationIndex) {
        representativeOnsetIndex =
          lastWaveformIndex - representativeStripLength;
        representativeTerminationIndex = lastWaveformIndex;
      }
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          representativeStripInfo: {
            ...action.newInfo,
            representativeOnsetIndex,
            representativeTerminationIndex,
          },
        },
      };
    case RESET_REPRESENTATIVE_STRIP_INFO:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          representativeStripInfo: {
            ...initialState.eventReview.representativeStripInfo,
          },
        },
      };
    // Add Report Management
    case SET_ADD_REPORT_EVENT_START:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          addReport: {
            ...initialState.eventReview.addReport,
            addStep: 1,
            eventType: action.eventType,
            ...(action.prevSubState ?? {}),
          },
        },
      };
    case SET_ADD_REPORT_EVENT_CLOSE:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          addReport: {
            ...initialState.eventReview.addReport,
          },
        },
      };
    case ADJUST_ADD_REPORT_EVENT_NEW_STATE:
      // addStep 이 2로 변경될 때 selectedRepresentativeInfo.
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          addReport: {
            ...state.eventReview.addReport,
            ...action.newState,
          },
        },
      };
    case SET_CHART_SELECTED_STRIP:
      const chartSelectedTimestamp =
        action.selectedTimeMs - (action.selectedTimeMs % 30000);

      if (chartSelectedTimestamp === state.eventReview.chartSelectedTimestamp) {
        return {
          ...state,
        };
      }
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          chartSelectedTimestamp,
        },
      };
    // Update ECG Test Info. in Global State
    case UPDATE_ECG_TEST_INFO:
      return {
        ...state,
        ecgTest: {
          ...state.ecgTest,
          data: {
            ...state.ecgTest.data,
            [action.key]: action.value,
          },
        },
      };
    case SET_BASIC_LEAD_OFF:
      return {
        ...state,
        timeEventsList: {
          ...state.timeEventsList,
          leadOff: mergeLeadOffInfo(
            state.timeEventsList.leadOff,
            action.basicLeadOffList
          ),
        },
      };

    // Get ECG Test
    case GET_ECG_TEST_REQUESTED:
      return {
        ...state,
        ecgTest: {
          ...state.ecgTest,
          pending: true,
          error: null,
        },
      };
    case GET_ECG_TEST_SUCCEED:
      return {
        ...state,
        recordingTime: {
          recordingStartMs: DateUtil.formatMs(
            action.data.patchecg.startTimestamp
          ),
          recordingEndMs: DateUtil.formatMs(action.data.patchecg.endTimestamp),
        },
        ecgTest: {
          ...state.ecgTest,
          pending: false,
          data: {
            ...action.data,
            summary: {
              ...action.data.summary,
              analyzedTime: action.data.summary?.analyzedTime || 0,
              recordingTime:
                action.data.summary?.recordingTime ||
                (action.data.patchecg.endTimestamp -
                  action.data.patchecg.startTimestamp) *
                  1000,
            },
          },
        },
      };
    case GET_ECG_TEST_FAILED:
      return {
        ...state,
        ecgTest: {
          ...state.ecgTest,
          pending: false,
          error: action.error,
        },
      };
    // Get event detail
    case GET_EVENT_DETAIL_REQUESTED:
      return {
        ...state,
        eventDetail: {
          ...state.eventDetail,
          pending: true,
          error: null,
        },
      };
    case GET_EVENT_DETAIL_SUCCEED:
      return {
        ...state,
        eventDetail: {
          pending: false,
          data: action.data,
          error: null,
        },
        eventReview: {
          ...state.eventReview,
          sidePanelState: {
            ...state.eventReview.sidePanelState,
            selectedValueList: action.newSelectedValueList,
          },
        },
      };
    case GET_EVENT_DETAIL_FAILED:
      return {
        ...state,
        eventDetail: {
          pending: false,
          data: null,
          error: action.error,
        },
      };
    // Get ecgs statistics
    case GET_ECGS_STATISTICS_REQUESTED:
      return {
        ...state,
        ecgStatistics: {
          pending: true,
          error: null,
        },
      };
    case GET_ECGS_STATISTICS_SUCCEED:
      return {
        ...state,
        ecgStatistics: {
          pending: false,
          data: action.data,
          error: null,
        },
      };
    case GET_ECGS_STATISTICS_FAILED:
      return {
        ...state,
        ecgStatistics: {
          pending: false,
          error: action.error,
        },
      };
    // Get reports statistics
    case GET_REPORTS_STATISTICS_REQUESTED:
      return {
        ...state,
        reportStatistics: {
          pending: true,
          error: null,
        },
      };
    case GET_REPORTS_STATISTICS_SUCCEED:
      return {
        ...state,
        reportStatistics: {
          pending: false,
          data: action.data,
          error: null,
        },
      };
    case GET_REPORTS_STATISTICS_FAILED:
      return {
        ...state,
        reportStatistics: {
          pending: false,
          error: action.error,
        },
      };
    // get all statistics
    case GET_ALL_STATISTICS_REQUESTED:
      return {
        ...state,
        allStatistics: {
          pending: true,
          error: null,
        },
      };
    case GET_ALL_STATISTICS_SUCCEED:
      return {
        ...state,
        ecgStatistics: {
          ...state.ecgStatistics,
          data: action.data.ecgStatistics,
        },
        reportStatistics: {
          ...state.reportStatistics,
          data: action.data.reportStatistics,
        },
        allStatistics: {
          pending: false,
          data: action.data,
          error: null,
        },
      };
    case GET_ALL_STATISTICS_FAILED:
      return {
        ...state,
        allStatistics: {
          pending: false,
          error: action.error,
        },
      };
    // Adjust ecgs statistics
    case ADJUST_ECGS_STATISTICS:
      return {
        ...state,
        ecgStatistics: {
          ...state.ecgStatistics,
          data: {
            ...state.ecgStatistics.data,
            [action.eventSection]:
              state.ecgStatistics.data[action.eventSection] +
              action.adjustValue,
          },
        },
      };
    // Adjust reports statistics
    case ADJUST_REPORTS_STATISTICS:
      return {
        ...state,
        reportStatistics: {
          ...state.reportStatistics,
          data: {
            ...state.reportStatistics.data,
            [action.reportSection]:
              state.reportStatistics.data[action.reportSection] +
              action.adjustValue,
          },
        },
      };
    // GET report events
    case GET_REPORT_EVENTS_REQUESTED:
      return {
        ...state,
        reportDetail: {
          ...state.reportDetail,
          pending: true,
          error: null,
        },
        eventDetail: {
          ...state.eventDetail,
          pending: true,
          error: null,
        },
      };
    case GET_REPORT_EVENTS_SUCCEED:
      return {
        ...state,
        reportDetail: {
          pending: false,
          data: action.data,
          error: null,
        },
      };
    case GET_REPORT_EVENTS_FAILED:
      return {
        ...state,
        reportDetail: {
          pending: false,
          error: action.error,
        },
      };
    // POST report events
    case POST_REPORT_EVENT_REQUESTED:
      return {
        ...state,
        reportEvents: { ...state.reportEvents, pending: true, error: null },
        // API 응답전 선반영
        eventDetail: {
          ...state.eventDetail,
          pending: true,
          data: {
            ...state.eventDetail.data,
            registeredReport: [
              ...state.eventDetail.data.registeredReport,
              {
                ...action.newAddReportInfo,
                reportEventId: null,
              },
            ],
          },
        },
      };
    case POST_REPORT_EVENT_SUCCEED:
      return {
        ...state,
        reportEvents: {
          ...state.reportEvents,
          pending: false,
          data: action.data,
        },
        // API 응답후 롤백
        eventDetail: {
          ...state.eventDetail,
          pending: false,
          data: {
            ...state.eventDetail.data,
            registeredReport: [
              ...state.eventDetail.data.registeredReport.filter(
                (value) => value.reportEventId !== null
              ),
              {
                ...action.data,
              },
            ],
          },
        },
      };
    case POST_REPORT_EVENT_FAILED:
      return {
        ...state,
        reportEvents: {
          ...state.eventDetail,
          pending: false,
          error: action.error,
        },
        eventDetail: {
          ...state.eventDetail,
          pending: false,
          data: {
            ...state.eventDetail.data,
            registeredReport: [
              ...state.eventDetail.data.registeredReport.filter(
                (value) => value.reportEventId !== null
              ),
            ],
          },
        },
      };
    // update report event
    case UPDATE_REPORT_EVENT_REQUESTED:
      return {
        ...state,
        reportEvents: {
          ...state.reportEvents,
          pending: true,
        },
        // API 응답전 선반영
        ...(() => {
          if (action.isNotPreUpdate) {
            return {};
          } else {
            if (
              state.eventReview.sidePanelState.tabValue ===
              EVENT_GROUP_TYPE.EVENTS
            ) {
              return {
                eventDetail: {
                  ...state.eventDetail,
                  pending: true,
                  data: {
                    ...state.eventDetail.data,
                    registeredReport:
                      state.eventDetail.data.registeredReport.map((value) =>
                        value.reportEventId !== action.reportEventId
                          ? { ...value }
                          : {
                              ...value,
                              ...action.newAddReportInfo,
                            }
                      ),
                  },
                },
              };
            } else {
              return {
                eventDetail: {
                  ...state.eventDetail,
                  pending: true,
                },
                reportDetail: {
                  ...state.reportDetail,
                  pending: true,
                  data: {
                    ...state.reportDetail.data,
                    ...action.newAddReportInfo,
                  },
                },
              };
            }
          }
        })(),
      };
    case UPDATE_REPORT_EVENT_SUCCEED:
      return {
        ...state,
        reportEvents: {
          ...state.reportEvents,
          pending: false,
          data: action.data,
        },
        // API 응답후 선반영 후조치
        ...(() => {
          if (action.isNotPreUpdate) {
            return {};
          } else {
            if (
              state.eventReview.sidePanelState.tabValue ===
              EVENT_GROUP_TYPE.EVENTS
            ) {
              return {
                eventDetail: {
                  ...state.eventDetail,
                  pending: false,
                },
              };
            } else {
              return {
                eventDetail: {
                  ...state.eventDetail,
                  pending: false,
                },
                reportDetail: {
                  ...state.reportDetail,
                  pending: false,
                },
              };
            }
          }
        })(),
      };
    case UPDATE_REPORT_EVENT_FAILED:
      return {
        ...state,
        reportEvents: {
          pending: false,
          error: action.error,
        },
        // API 응답후 선반영 후조치
        ...(() => {
          if (action.isNotPreUpdate) {
            return {};
          } else {
            if (
              state.eventReview.sidePanelState.tabValue ===
              EVENT_GROUP_TYPE.EVENTS
            ) {
              return {
                eventDetail: {
                  ...state.eventDetail,
                  pending: false,
                },
              };
            } else {
              return {
                eventDetail: {
                  ...state.eventDetail,
                  pending: false,
                },
                reportDetail: {
                  ...state.reportDetail,
                  pending: false,
                },
              };
            }
          }
        })(),
      };
    // delete report event
    case DELETE_REPORT_EVENT_REQUESTED:
      return {
        ...state,
        reportEvents: {
          ...state.reportEvents,
          pending: true,
        },
        // Side Panel Tab 이 Events 인 경우 API 응답전 선반영
        ...(() =>
          state.eventReview.sidePanelState.tabValue === EVENT_GROUP_TYPE.EVENTS
            ? {
                eventDetail: {
                  ...state.eventDetail,
                  pending: true,
                  data: {
                    ...state.eventDetail.data,
                    registeredReport:
                      state.eventDetail.data.registeredReport.filter(
                        (value) => value.reportEventId !== action.reportEventId
                      ),
                  },
                },
              }
            : {})(),
      };
    case DELETE_REPORT_EVENT_SUCCEED:
      return {
        ...state,
        reportEvents: {
          ...state.reportEvents,
          pending: false,
        },
        // Side Panel Tab 이 Events 인 경우 API 응답후 선반영 후조치
        ...(() =>
          state.eventReview.sidePanelState.tabValue === EVENT_GROUP_TYPE.EVENTS
            ? {
                eventDetail: {
                  ...state.eventDetail,
                  pending: false,
                },
              }
            : {})(),
      };
    case DELETE_REPORT_EVENT_FAILED:
      return {
        ...state,
        reportEvents: {
          pending: false,
          error: action.error,
        },
        // Side Panel Tab 이 Events 인 경우 API 응답후 선반영 후조치
        ...(() =>
          state.eventReview.sidePanelState.tabValue === EVENT_GROUP_TYPE.EVENTS
            ? {
                eventDetail: {
                  ...state.eventDetail,
                  pending: false,
                },
              }
            : {})(),
      };
    // Get entire events
    case GET_TIME_EVENTS_LIST_REQUESTED:
      return {
        ...state,
        timeEventsList: {
          ...state.timeEventsList,
          pending: true,
          error: null,
        },
      };
    case GET_TIME_EVENTS_LIST_SUCCEED:
      if (action.targetTimeEventType) {
        if (action.targetTimeEventType === TIME_EVENT_TYPE.LEAD_OFF) {
          return {
            ...state,
            timeEventsList: {
              ...state.timeEventsList,
              pending: false,
              leadOff: mergeLeadOffInfo(
                state.timeEventsList.leadOff,
                transformTimeEvents(action.data)
              ),
            },
          };
        } else {
          return {
            ...state,
            timeEventsList: {
              ...state.timeEventsList,
              pending: false,
              data: [
                ...state.timeEventsList.data.filter(
                  (value) =>
                    value.type !==
                    getEventInfoByQuery({
                      timeEventType: action.targetTimeEventType,
                    }).type
                ),
                ...transformTimeEvents(action.data),
              ],
            },
          };
        }
      } else {
        return {
          ...state,
          timeEventsList: {
            ...state.timeEventsList,
            pending: false,
            data: transformTimeEvents(action.data),
          },
        };
      }
    case GET_TIME_EVENTS_LIST_FAILED:
      return {
        ...state,
        timeEventsList: {
          ...state.timeEventsList,
          pending: false,
          error: action.error,
        },
      };
    // get beats, ectopics list
    case GET_BEATS_N_ECTOPIC_LIST_REQUESTED:
      return {
        ...state,
        beatsNEctopicList: {
          ...state.beatsNEctopicList,
          pending: true,
          error: null,
        },
      };
    case GET_BEATS_N_ECTOPIC_LIST_SUCCEED:
      // const oldEcgRawList = [...state.ecgRaw.ecgRawList];
      return {
        ...state,
        beatsNEctopicList: {
          ...state.beatsNEctopicList,
          pending: false,
          data: mergeBeatEventInfoMap(
            state.beatsNEctopicList.data,
            action.data
          ),
        },
      };
    case GET_BEATS_N_ECTOPIC_LIST_FAILED:
      return {
        ...state,
        beatsNEctopicList: {
          ...state.beatsNEctopicList,
          pending: false,
          error: action.error,
        },
      };
    // Get daily heart rate
    case GET_DAILY_HEART_RATE_REQUESTED:
      return {
        ...state,
        hrv: {
          ...state.hrv,
          pending: true,
          error: null,
        },
      };
    case GET_DAILY_HEART_RATE_SUCCEED:
      return {
        ...state,
        hrv: {
          ...state.hrv,
          pending: false,
          data: action.data,
        },
        patientEvents: action.patientEvents,
      };
    case GET_DAILY_HEART_RATE_FAILED:
      return {
        ...state,
        hrv: {
          ...state.hrv,
          pending: false,
          error: action.error,
        },
      };
    // Get ecgRaw data
    case GET_ECGRAW_INIT_REQUESTED:
      let initAtTime = action.atTime;
      return {
        ...state,
        ecgRaw: {
          ...state.ecgRaw,
          ecgRawList: action.isInit ? [] : state.ecgRaw.ecgRawList,
          pending: true,
          // todo: jyoon[221023] backwardPending, forwardPending true 여부 조건 필요.
          backwardPending: true,
          forwardPending: true,
          // pending: action.isInit ? true : state.ecgRaw.pending,
          // backwardPending:
          //   action.isScroll && action.isBackward
          //     ? true
          //     : state.ecgRaw.backwardPending,
          // forwardPending:
          //   action.isScroll && action.isForward
          //     ? true
          //     : state.ecgRaw.forwardPending,

          // isBackward:
          //   action.isScroll && action.isBackward
          //     ? true
          //     : state.ecgRaw.isBackward,

          // isForward: action.isForward ? true : state.ecgRaw.isForward,
          withBeat: action.withBeat,
          isBeatStrip: action.isBeatStrip,
          initAtTime,
          error: null,
        },
      };
    case GET_ECGRAW_BACKWARD_REQUESTED:
    case GET_ECGRAW_FORWARD_REQUESTED:
    case GET_ECGRAW_REQUESTED:
      return {
        ...state,
        ecgRaw: {
          ...state.ecgRaw,
          ecgRawList: action.isInit ? [] : state.ecgRaw.ecgRawList,
          pending: action.isInit ? true : state.ecgRaw.pending,
          backwardPending:
            action.isScroll && action.isBackward
              ? true
              : state.ecgRaw.backwardPending,
          forwardPending:
            action.isScroll && action.isForward
              ? true
              : state.ecgRaw.forwardPending,
          isBackward:
            action.isScroll && action.isBackward
              ? true
              : state.ecgRaw.isBackward,

          isForward: action.isForward ? true : state.ecgRaw.isForward,
          withBeat: action.withBeat,
          isBeatStrip: action.isBeatStrip,
          error: null,
        },
      };
    case GET_ECGRAW_SUCCEED:
      const {
        results,
        action: {
          atTime,
          isBackward,
          isForward,
          isInit,
          isJumpToTime,
          isScroll,
          initAtTimeLocalState,
        },
        newEcgRawList,
      } = action;

      DEBUGGING_LOG_ECG_RAW &&
        console.log('🚨🚨🚨 log 🚨🚨🚨 - GET_ECGRAW_SUCCEED', {
          initAtTimeLocalState: DateUtil.formatDateTime(initAtTimeLocalState),
          'state.ecgRaw.initAtTime': DateUtil.formatDateTime(
            state.ecgRaw.initAtTime
          ),
          isInit,
          resultIndex_0: DateUtil.formatDateTime(results.at(0).onsetMs),
          'resultIndex_-1': DateUtil.formatDateTime(results.at(-1).onsetMs),
        });
      if (initAtTimeLocalState !== state.ecgRaw.initAtTime) {
        console.error('infinity scroll initTime error');
        return { ...state };
      }

      let rawApiResult, scrollType, navigatorTime, caretTime;
      let updatedPending = state.ecgRaw.pending;
      let updatedBackwardPending = state.ecgRaw.backwardPending;
      let updatedForwardPending = state.ecgRaw.forwardPending;

      rawApiResult = results;
      navigatorTime = isInit && atTime;
      caretTime = state.eventReview?.ecgCaretTimestamp || null;

      if (isInit) {
        updatedPending = false;
      }
      if (isScroll && isBackward) {
        scrollType = 'up';
        updatedBackwardPending = false;
      }
      if (isScroll && isForward) {
        scrollType = 'down';
        updatedForwardPending = false;
      }

      DEBUGGING_LOG_ECG_RAW &&
        newEcgRawList.forEach((v) => {
          if (v.onsetMs === results.at(0).onsetMs) {
            console.log('onsetMs: ', DateUtil.formatDateTime(v.onsetMs), '* ');
          } else if (v.onsetMs === state.ecgRaw.initAtTime) {
            console.log(
              'extra Init > onsetMs: ',
              DateUtil.formatDateTime(v.onsetMs),
              '* '
            );
          } else {
            console.log('onsetMs: ', DateUtil.formatDateTime(v.onsetMs));
          }
        });
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          chartSelectedTimestamp: 0,
        },
        ecgRaw: {
          ...state.ecgRaw,
          // pending
          pending: updatedPending,
          backwardPending: isInit
            ? state.ecgRaw.backwardPending
            : updatedBackwardPending,
          forwardPending: isInit
            ? state.ecgRaw.forwardPending
            : updatedForwardPending,
          // data list
          ecgRawList: [...newEcgRawList],
          ecgRawSection: {
            beginOnset: newEcgRawList.at(0).onsetMs,
            endTermination: newEcgRawList.at(-1).onsetMs,
          },
          // fetching ecgRaw data option
          isJumpToTime: isJumpToTime,
          navigatorTime: navigatorTime,
          caretTime: caretTime,
          scrollType,
          prependDataLength: isScroll && isBackward ? rawApiResult.length : 0,
        },
      };
    case GET_ECGRAW_INIT_SUCCEED:
      const {
        action: { backwardListLength, initExtraSelection },
        newEcgRawList: extraInitNewEcgRawList,
      } = action;

      DEBUGGING_LOG_ECG_RAW &&
        extraInitNewEcgRawList.forEach((v) => {
          if (v.onsetMs === initExtraSelection.backward?.onset) {
            console.log(
              'extra Init > onsetMs: ',
              DateUtil.formatDateTime(v.onsetMs),
              '* '
            );
          } else if (v.onsetMs === initExtraSelection.forward?.onset) {
            console.log(
              'extra Init > onsetMs: ',
              DateUtil.formatDateTime(v.onsetMs),
              '* '
            );
          } else if (v.onsetMs === state.ecgRaw.initAtTime) {
            console.log(
              'extra Init > onsetMs: ',
              DateUtil.formatDateTime(v.onsetMs),
              '* '
            );
          } else {
            console.log(
              'extra Init > onsetMs: ',
              DateUtil.formatDateTime(v.onsetMs)
            );
          }
        });

      return {
        ...state,
        ecgRaw: {
          ...state.ecgRaw,
          // pending
          backwardPending: false,
          forwardPending: false,

          // direction
          isBackward: true,
          isForward: true,

          // data list
          ecgRawList: [...extraInitNewEcgRawList],
          ecgRawSection: {
            beginOnset: extraInitNewEcgRawList.at(0).onsetMs,
            endTermination: extraInitNewEcgRawList.at(-1).onsetMs,
          },
          initExtraSelection: {
            backward: {
              onset: initExtraSelection.backward.onset,
              termination: initExtraSelection.backward.termination,
            },
            forward: {
              onset: initExtraSelection.forward.onset,
              termination: initExtraSelection.forward.onset,
            },
          },

          // option
          prependDataLength: backwardListLength,
        },
      };

    case GET_ECGRAW_FAILED:
      return {
        ...state,
        ecgRaw: {
          ...state.ecgRaw,
          pending: false,
          backwardPending: false,
          forwardPending: false,
          error: action.error,
        },
      };
    // POST Beats - 비트추가
    case POST_BEATS_REQUESTED:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            pending: true,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: true,
          error: null,
        },
      };
    case POST_BEATS_SUCCEED:
      let newBeatLabelButtonDataListAfterPostBeats;
      (function () {
        const {
          data: { result: apiResResult },
          tabType,
        } = action;
        const { beatLabelButtonDataList, onsetWaveformIdx } =
          state.eventReview.tenSecStripDetail;

        const editTargetWaveformIndex =
          apiResResult.waveformIndex[0] - onsetWaveformIdx;
        const editTargetBeatType = apiResResult.beatType[0];
        const nextIndexOfAddBeat = beatLabelButtonDataList.findIndex(
          (v) => v.xAxisPoint > editTargetWaveformIndex
        );
        beatLabelButtonDataList.splice(nextIndexOfAddBeat, 0, {
          xAxisPoint: editTargetWaveformIndex,
          beatType: editTargetBeatType,
          title: TEN_SEC_STRIP_EDIT.BEAT_TYPE[editTargetBeatType],
          color: TEN_SEC_STRIP_EDIT.BEAT_COLOR_TYPE[editTargetBeatType],
          isSelected: false,
          isEventReview: '',
        });
        newBeatLabelButtonDataListAfterPostBeats = beatLabelButtonDataList;
      })();

      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            beatLabelButtonDataList: [
              ...newBeatLabelButtonDataListAfterPostBeats,
            ],
            pending: false,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: false,
          error: null,
        },
      };
    case POST_BEATS_FAILED:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            pending: false,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: false,
          error: null,
        },
      };
    // PATCH Beats
    case PATCH_BEATS_REQUESTED:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            pending: true,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: true,
          error: null,
        },
      };
    case PATCH_BEATS_SUCCEED:
      // 업데이트 성공시 get 재호출
      // 10s strip detail에서 업데이트 하는 경우만
      let newBeatLabelButtonDataListAfterPatchBeats;
      let updateBeatLabelButtonDataList = false;

      (function () {
        const {
          data: { result: apiResResult },
          tabType,
        } = action;

        if (tabType === TEN_SEC_STRIP_DETAIL.TAB.ARRHYTHMIA_CONTEXTMENU) return;

        updateBeatLabelButtonDataList = true;
        const { beatLabelButtonDataList, onsetWaveformIdx } =
          state.eventReview.tenSecStripDetail;

        for (let i in apiResResult.waveformIndex) {
          newBeatLabelButtonDataListAfterPatchBeats =
            beatLabelButtonDataList.map((v) => {
              if (
                v.xAxisPoint ===
                apiResResult.waveformIndex[i] - onsetWaveformIdx
              ) {
                v.isSelected = false;
                v.beatType = apiResResult.beatType[i];
                v.title = TEN_SEC_STRIP_EDIT.BEAT_TYPE[v.beatType];
                v.color = TEN_SEC_STRIP_EDIT.BEAT_COLOR_TYPE[v.beatType];
                return v;
              }
              return v;
            });
        }
      })();

      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            beatLabelButtonDataList: updateBeatLabelButtonDataList
              ? [...newBeatLabelButtonDataListAfterPatchBeats]
              : state.eventReview.tenSecStripDetail.beatLabelButtonDataList,
            pending: false,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: false,
          error: null,
        },
      };
    case PATCH_BEATS_FAILED:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            pending: false,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: false,
          error: null,
        },
      };
    // DELETE Beats
    case DELETE_BEATS_REQUESTED:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            pending: true,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: true,
          error: null,
        },
      };
    case DELETE_BEATS_SUCCEED:
      let newBeatLabelButtonDataListAfterDeleteBeats;

      (function () {
        const { reqBody } = action;
        const { beatLabelButtonDataList, onsetWaveformIdx } =
          state.eventReview.tenSecStripDetail;

        const editTargetWaveformIndex =
          reqBody.waveformIndexes[0] - onsetWaveformIdx;
        const nextIndexOfAddBeat = beatLabelButtonDataList.findIndex(
          (v) => v.xAxisPoint > editTargetWaveformIndex
        );
        beatLabelButtonDataList.splice(nextIndexOfAddBeat - 1, 1);
        newBeatLabelButtonDataListAfterDeleteBeats = beatLabelButtonDataList;
      })();

      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            beatLabelButtonDataList: [
              ...newBeatLabelButtonDataListAfterDeleteBeats,
            ],
            pending: false,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: false,
          error: null,
        },
      };
    case DELETE_BEATS_FAILED:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...state.eventReview.tenSecStripDetail,
            pending: false,
            error: null,
          },
        },
        beats: {
          ...state.beats,
          pending: false,
          error: null,
        },
      };
    // Edit feature
    case SET_SELECTION_STRIP:
      const selectionStrip = action.selectionStrip;

      let newSelectionStrip = {};
      let newSelectionStripState;

      // eslint-disable-next-line default-case
      switch (selectionStrip.selectionMarkerType) {
        case SELECTION_MARKER_TYPE.ONSET:
          newSelectionStrip = {
            onset: {
              representativeTimestamp: selectionStrip.representativeTimestamp,
              representativeWaveformIndex:
                selectionStrip.representativeWaveformIndex,
              clickedTimestamp:
                selectionStrip.representativeTimestamp +
                selectionStrip.clickedWaveformIndex * 4,
              clickedWaveformIndex: selectionStrip.clickedWaveformIndex,
            },
            termination: {
              representativeTimestamp: undefined,
              representativeWaveformIndex: undefined,
              clickedTimestamp: undefined,
              clickedWaveformIndex: undefined,
            },
          };

          newSelectionStripState = {
            ...newSelectionStrip,
          };

          return {
            ...state,
            eventReview: {
              ...state.eventReview,
              selectionStrip: { ...newSelectionStripState },
              tenSecStrip: {
                ...state.eventReview.tenSecStrip,
                representativeCenterTimeStamp:
                  selectionStrip.representativeTimestamp,
                representativeCenterWaveformIndex:
                  selectionStrip.representativeWaveformIndex,
                centerWaveformIndex: selectionStrip.clickedWaveformIndex,
              },
            },
          };

        case SELECTION_MARKER_TYPE.TERMINATION:
          newSelectionStrip.termination = {
            representativeTimestamp: selectionStrip.representativeTimestamp,
            representativeWaveformIndex:
              selectionStrip.representativeWaveformIndex,
            clickedTimestamp:
              selectionStrip.representativeTimestamp +
              selectionStrip.clickedWaveformIndex * 4,
            clickedWaveformIndex: selectionStrip.clickedWaveformIndex,
          };

          newSelectionStripState = {
            ...state.eventReview.selectionStrip,
            ...newSelectionStrip,
          };

          let isSwapCondition, isSwapCurrTerminationWithPrevTermination;

          const {
            onset: {
              representativeTimestamp: onsetRepresentativeTimestamp,
              clickedWaveformIndex: onsetWaveformIndex,
            },
            termination: {
              representativeTimestamp: terminationRepresentativeTimestamp,
              clickedWaveformIndex: terminationWaveformIndex,
            },
          } = newSelectionStripState;

          if (
            (onsetRepresentativeTimestamp ===
              terminationRepresentativeTimestamp &&
              onsetWaveformIndex > terminationWaveformIndex) || // single line
            onsetRepresentativeTimestamp > terminationRepresentativeTimestamp // multi line
          ) {
            const swap = newSelectionStripState.termination;
            newSelectionStripState.termination = newSelectionStripState.onset;
            newSelectionStripState.onset = swap;
          }

          if (
            state.eventReview.selectionStrip.termination
              .representativeWaveformIndex !== undefined &&
            newSelectionStrip.termination.representativeWaveformIndex +
              newSelectionStrip.termination.clickedWaveformIndex <
              state.eventReview.selectionStrip.onset
                .representativeWaveformIndex +
                state.eventReview.selectionStrip.onset.clickedWaveformIndex
          ) {
            newSelectionStripState.termination =
              state.eventReview.selectionStrip.termination;
          }

          // onset이 termination보다 클때
          isSwapCondition = () => {
            return (
              (onsetRepresentativeTimestamp ===
                terminationRepresentativeTimestamp &&
                onsetWaveformIndex > terminationWaveformIndex) || // single line
              onsetRepresentativeTimestamp > terminationRepresentativeTimestamp // multi line
            );
          };
          // onset, termination이 이미 모두 있을때, shift+click으로 termination을 update시켜줄때 onset 보다 작은 시점을 클릭 했을때
          //  => 이전의 termination을 현재 termination으로 update
          isSwapCurrTerminationWithPrevTermination = () => {
            return (
              state.eventReview.selectionStrip.termination
                .representativeWaveformIndex !== undefined &&
              newSelectionStrip.termination.representativeWaveformIndex +
                newSelectionStrip.termination.clickedWaveformIndex <
                state.eventReview.selectionStrip.onset
                  .representativeWaveformIndex +
                  state.eventReview.selectionStrip.onset.clickedWaveformIndex
            );
          };

          break;
        case SELECTION_MARKER_TYPE.RESET:
          newSelectionStripState = initialState.eventReview.selectionStrip;
          break;
      }

      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          selectionStrip: { ...newSelectionStripState },
        },
      };
    case SET_TENSEC_STRIP:
      // init - reset
      let newState = {
        representativeCenterTimeStamp:
          action.tenSecStrip.representativeCenterTimeStamp,
        representativeCenterWaveformIndex:
          action.tenSecStrip.representativeCenterWaveformIndex,
        centerWaveformIndex: action.tenSecStrip.centerWaveformIndex,
      };

      const MAIN = action.tenSecStrip[TEN_SEC_STRIP.TYPE.MAIN];
      const EXTRA = action.tenSecStrip[TEN_SEC_STRIP.TYPE.EXTRA];
      const RESET = action.tenSecStrip[TEN_SEC_STRIP.TYPE.RESET];

      if (RESET) {
        return {
          ...state,
          eventReview: {
            ...state.eventReview,
            tenSecStrip: {
              ...initialState.eventReview.tenSecStrip,
            },
          },
        };
      }

      if (MAIN && MAIN.representativeTimestamp !== undefined) {
        Object.assign(newState, {
          main: MAIN,
        });
      }

      if (EXTRA) {
        if (EXTRA.representativeTimestamp !== undefined) {
          Object.assign(newState, {
            extra: EXTRA,
          });
        } else {
          Object.assign(newState, {
            extra: initialState.eventReview.tenSecStrip.extra,
          });
        }
      }

      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStrip: {
            ...state.eventReview.tenSecStrip,
            ...newState,
          },
        },
      };
    case SET_TENSEC_STRIP_DETAIL:
      const { tenSecStripDetail } = action;
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          tenSecStripDetail: {
            ...tenSecStripDetail,
          },
        },
      };
    case SET_ARRHYTHMIA_CONTEXTMENU:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          isOpenArrhythmiaContextmenu: action.isOpenArrhythmiaContextmenu,
        },
      };
    // 10s strip detail edit feature
    case SET_BEAT_CONTEXTMENU:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          isOpenBeatContextmenu: action.isOpenBeatContextmenu,
        },
      };
    // post TimeEvent when edit Beat on ContextMenu
    case POST_TIME_EVENT_REQUESTED:
      return {
        ...state,
        updateTimeEvent: {
          pending: true,
          data: {},
          error: null,
        },
      };
    case POST_TIME_EVENT_SUCCEED:
      return {
        ...state,
        updateTimeEvent: {
          pending: false,
          data: action.data,
          error: null,
        },
      };
    case POST_TIME_EVENT_FAILED:
      return {
        ...state,
        updateTimeEvent: {
          pending: false,
          data: {},
          error: action.error,
        },
      };
    // event review tab feature
    case SET_ECGCHARTLIST_SCROLL_TOP:
      return {
        ...state,
        eventReview: {
          ...state.eventReview,
          ecgChartListScrollTop: action.ecgChartListScrollTop,
          chartSelectedTimestamp: 0,
        },
      };
    // Request Print Report
    // refactor(진현) : 리포트 상태 따로 관리 필요
    case REQUEST_PRINT_REPORT_REQUESTED:
      return {
        ...state,
        ecgTest: {
          ...state.ecgTest,
          pending: true,
          error: null,
        },
        reportState: {
          ...state.reportState,
          pending: true,
          error: null,
        },
      };
    case REQUEST_PRINT_REPORT_SUCCEED:
      return {
        ...state,
        ecgTest: {
          ...state.ecgTest,
          pending: false,
          data: {
            ...state.ecgTest.data,
            summary: action.data,
          },
        },
        reportState: {
          ...state.reportState,
          pending: false,
          data: action.data,
        },
      };
    case REQUEST_PRINT_REPORT_FAILED:
      return {
        ...state,
        ecgTest: {
          ...state.ecgTest,
          pending: false,
          error: action.error,
        },
        reportState: {
          ...state.reportState,
          pending: false,
          error: action.error,
        },
      };
    case SET_IS_ECGCHARTLIST_SCROLL_TO_INDEX:
    default:
      return state;
  }
}

// Action Creators
export function initializeState(ecgTestId, targetSection) {
  if (ecgTestId) return { type: INITIALIZE, ecgTestId, targetSection };
}

// EntireEcgFragment Data
export function setNavigatorTimestamp(timestamp, isInit) {
  return { type: SET_NAVIGATOR_TIMESTAMP, timestamp, isInit };
}
export function setHrHighlight(timestamp) {
  return { type: SET_HR_HIGHLIGHT_TIMESTAMP, timestamp };
}

// Handle sidePanelState
export function setSidePanelTabValue(tabValue) {
  return { type: SET_SIDE_PANEL_TAB_VALUE, tabValue };
}
/**
 * Side Panel 의 선택된 이벤트 정보 배열(`sidePanelState.selectedValueList`)을 업데이트 하는 Action
 *
 * Action 처리 후 Side Panel 의 텝에 따라 조회 API 요청함(`_setSelectedValueListHandler`)
 * @param {{type, position, timeEventId, waveformIndex}[]} newSelectedValueList
 * @param {Boolean} isFromChart 정보 업데이트가 어디서 발생됐는지 확인용, true 면 차트 스크롤 이동 안함
 * @returns
 */
export function setSidePanelSelectedValueList(
  newSelectedValueList,
  isFromChart = false,
  isOnlySet = false
) {
  return {
    type: SET_SIDE_PANEL_SELECTED_VALUE_LIST,
    newSelectedValueList,
    isFromChart,
    isOnlySet,
  };
}

// Representative Strip State Management
/**
 *
 * @param {{selectedMs: Timestamp, representativeOnsetIndex: WaveformIndex, representativeTerminationIndex: WaveformIndex}} newInfo
 * @returns
 */
export function setRepresentativeStripInfo(newInfo) {
  // stale representative marker remove
  // 😱😱😱
  const chartEditInst = ChartUtil.chartEdit();
  chartEditInst.removeSelectionMarkerAll();
  chartEditInst.removeRepresentativeReportStrip();
  // 😱😱😱

  return { type: SET_REPRESENTATIVE_STRIP_INFO, newInfo };
}
export function resetRepresentativeStripInfo() {
  // stale representative marker remove
  // 😱😱😱
  const chartEditInst = ChartUtil.chartEdit();
  chartEditInst.removeSelectionMarkerAll();
  chartEditInst.removeRepresentativeReportStrip();
  // 😱😱😱

  return { type: RESET_REPRESENTATIVE_STRIP_INFO };
}

// Add Report Management
/**
 *
 * @param {EVENT_CONST_TYPES} eventType
 * @param {{reportEventId: String, prevTitle: String, selectedReportSection: REPORT_SECTION}?} prevSubState
 * @returns
 */
export function setAddReportEventStart(eventType, prevSubState) {
  return {
    type: SET_ADD_REPORT_EVENT_START,
    eventType,
    prevSubState,
  };
}
export function setAddReportEventClose() {
  return { type: SET_ADD_REPORT_EVENT_CLOSE };
}
export function adjustAddReportEventNewState(newState) {
  return { type: ADJUST_ADD_REPORT_EVENT_NEW_STATE, newState };
}

// Handle chart selected Strips
export function setChartSelectedStrip(selectedTimeMs) {
  return { type: SET_CHART_SELECTED_STRIP, selectedTimeMs };
}

// Update ECG Test Info. in Global State
export function updateEcgTestInfo(key, value) {
  return {
    type: UPDATE_ECG_TEST_INFO,
    key,
    value,
  };
}
function setBasicLeadOff(basicLeadOffList) {
  return {
    type: SET_BASIC_LEAD_OFF,
    basicLeadOffList,
  };
}

// Get ECG Test
export function getEcgTestRequested(isInitialized) {
  return { type: GET_ECG_TEST_REQUESTED, isInitialized };
}
export function getEcgTestSucceed(data) {
  return {
    type: GET_ECG_TEST_SUCCEED,
    data,
  };
}
function getEcgTestFailed(error) {
  return { type: GET_ECG_TEST_FAILED, error };
}

// Get single events
export function getEventDetailRequested(
  eventType,
  eventId,
  position,
  isSelectedValueUpdate,
  isIgnoreTimeJump
) {
  return {
    type: GET_EVENT_DETAIL_REQUESTED,
    eventType,
    eventId,
    position,
    isSelectedValueUpdate,
    isIgnoreTimeJump,
  };
}
function getEventDetailSucceed(data, newSelectedValueList) {
  return {
    type: GET_EVENT_DETAIL_SUCCEED,
    data: data,
    newSelectedValueList,
  };
}
function getEventDetailFailed(error) {
  return { type: GET_EVENT_DETAIL_FAILED, error };
}

// Get entire events
export function getTimeEventsListRequested(targetTimeEventType) {
  return { type: GET_TIME_EVENTS_LIST_REQUESTED, targetTimeEventType };
}
function getTimeEventsListSucceed(targetTimeEventType, data) {
  return {
    type: GET_TIME_EVENTS_LIST_SUCCEED,
    targetTimeEventType,
    data,
  };
}
function getTimeEventsListFailed(error) {
  return { type: GET_TIME_EVENTS_LIST_FAILED, error };
}
export function getBeatsNEctopicListRequested(
  onsetWaveformIndex,
  terminationWaveformIndex
) {
  return {
    type: GET_BEATS_N_ECTOPIC_LIST_REQUESTED,
    onsetWaveformIndex,
    terminationWaveformIndex,
  };
}
export function getBeatsNEctopicListSucceed(data) {
  return {
    type: GET_BEATS_N_ECTOPIC_LIST_SUCCEED,
    data,
  };
}
function getBeatsNEctopicListFailed(error) {
  return { type: GET_BEATS_N_ECTOPIC_LIST_FAILED, error };
}

// Get daily heart rate
export function getDailyHeartRateRequested() {
  return { type: GET_DAILY_HEART_RATE_REQUESTED };
}
function getDailyHeartRateSucceed(data, patientEvents) {
  return {
    type: GET_DAILY_HEART_RATE_SUCCEED,
    data: data,
    patientEvents,
  };
}
function getDailyHeartRateFailed(error) {
  return { type: GET_DAILY_HEART_RATE_FAILED, error };
}

// Get ecgRaw data
export function getEcgRawInitRequested(
  atTime,
  secStep,
  isBackward,
  isForward,
  isInit = true,
  isJumpToTime = false,
  isScroll = false,
  initAtTimeLocalState
) {
  return {
    type: GET_ECGRAW_INIT_REQUESTED,
    atTime,
    secStep,
    isBackward,
    isForward,
    isInit,
    isJumpToTime,
    isScroll,
    initAtTimeLocalState,
  };
}
export function getEcgRawRequestedBackward(
  atTime,
  secStep,
  isBackward,
  isForward,
  isInit = true,
  isJumpToTime = false,
  isScroll = false,
  initAtTimeLocalState
) {
  return {
    type: GET_ECGRAW_BACKWARD_REQUESTED,
    atTime,
    secStep,
    isBackward,
    isForward,
    isInit,
    isJumpToTime,
    isScroll,
    initAtTimeLocalState,
  };
}
export function getEcgRawRequestedForward(
  atTime,
  secStep,
  isBackward,
  isForward,
  isInit = true,
  isJumpToTime = false,
  isScroll = false,
  initAtTimeLocalState
) {
  return {
    type: GET_ECGRAW_FORWARD_REQUESTED,
    atTime,
    secStep,
    isBackward,
    isForward,
    isInit,
    isJumpToTime,
    isScroll,
    initAtTimeLocalState,
  };
}
export function getEcgRawRequested(
  atTime,
  secStep,
  isBackward,
  isForward,
  isInit = true,
  isJumpToTime = false,
  isScroll = false,
  initAtTimeLocalState
) {
  return {
    type: GET_ECGRAW_REQUESTED,
    atTime,
    secStep,
    isBackward,
    isForward,
    isInit,
    isJumpToTime,
    isScroll,
    initAtTimeLocalState,
  };
}
function getEcgRawSucceed(results, action, newEcgRawList) {
  return {
    type: GET_ECGRAW_SUCCEED,
    results,
    action,
    newEcgRawList,
  };
}
function getEcgRawInitSucceed(results, action, newEcgRawList) {
  return {
    type: GET_ECGRAW_INIT_SUCCEED,
    results,
    action,
    newEcgRawList,
  };
}
function getEcgRawFailed(error) {
  return { type: GET_ECGRAW_FAILED, error };
}

// post beats
export function postBeatsRequested(
  reqBody,
  onsetWaveformIndex,
  terminationWaveformIndex,
  suffix,
  tabType
) {
  return {
    type: POST_BEATS_REQUESTED,
    reqBody,
    onsetWaveformIndex,
    terminationWaveformIndex,
    suffix,
    tabType,
  };
}
export function postBeatsSucceed(data) {
  return {
    type: POST_BEATS_SUCCEED,
    data,
  };
}
export function postBeatsFailed(error) {
  return {
    type: POST_BEATS_FAILED,
    error,
  };
}

// patch beats
export function patchBeatsRequested(
  reqBody,
  onsetWaveformIndex,
  terminationWaveformIndex,
  suffix,
  tabType
) {
  return {
    type: PATCH_BEATS_REQUESTED,
    reqBody,
    onsetWaveformIndex,
    terminationWaveformIndex,
    suffix,
    tabType,
  };
}
export function patchBeatsSucceed(data, tabType) {
  return {
    type: PATCH_BEATS_SUCCEED,
    data,
    tabType,
  };
}
export function patchBeatsFailed(error) {
  return {
    type: PATCH_BEATS_FAILED,
    error,
  };
}

// delete beats
export function deleteBeatsRequested(
  reqBody,
  onsetWaveformIndex,
  terminationWaveformIndex,
  suffix,
  tabType
) {
  return {
    type: DELETE_BEATS_REQUESTED,
    reqBody,
    onsetWaveformIndex,
    terminationWaveformIndex,
    suffix,
    tabType,
  };
}
export function deleteBeatsSucceed(reqBody) {
  return {
    type: DELETE_BEATS_SUCCEED,
    reqBody,
  };
}
export function deleteBeatsFailed(error) {
  return {
    type: DELETE_BEATS_FAILED,
    error,
  };
}
// 유효성 검사 로직에도 사용될 예정
export function getEcgsStatisticsRequest() {
  return {
    type: GET_ECGS_STATISTICS_REQUESTED,
  };
}
function getEcgsStatisticsSucceed(data) {
  return {
    type: GET_ECGS_STATISTICS_SUCCEED,
    data,
  };
}
function getEcgsStatisticsFailed(error) {
  return { type: GET_ECGS_STATISTICS_FAILED, error };
}

export function getReportsStatisticsRequest() {
  return {
    type: GET_REPORTS_STATISTICS_REQUESTED,
  };
}
function getReportsStatisticSucceed(data) {
  return {
    type: GET_REPORTS_STATISTICS_SUCCEED,
    data,
  };
}
function getReportStatisticFailed(error) {
  return {
    type: GET_REPORTS_STATISTICS_FAILED,
    error,
  };
}

export function getAllStatisticsRequest() {
  return {
    type: GET_ALL_STATISTICS_REQUESTED,
  };
}
function getAllStatisticsSucceed(data) {
  return {
    type: GET_ALL_STATISTICS_SUCCEED,
    data,
  };
}
function getAllStatisticsFailed(error) {
  return {
    type: GET_ALL_STATISTICS_FAILED,
    error,
  };
}

export function adjustEcgsStatistic(eventSection, adjustValue) {
  return {
    type: ADJUST_ECGS_STATISTICS,
    eventSection,
    adjustValue,
  };
}

export function adjustReportStatistic(reportSection, adjustValue) {
  return {
    type: ADJUST_REPORTS_STATISTICS,
    reportSection,
    adjustValue,
  };
}

export function getReportEventsRequested(reportSection, position = 1) {
  return { type: GET_REPORT_EVENTS_REQUESTED, reportSection, position };
}
function getReportEventsSucceed(data) {
  return { type: GET_REPORT_EVENTS_SUCCEED, data };
}
function getReportEventsFailed(error) {
  return { type: GET_REPORT_EVENTS_FAILED, error };
}

/**
 * @typedef AddReportEventInfoType
 * @property {String?} rid
 * @property {Number | null} timeEventId
 * @property {WaveformIndex | null} waveformIndex
 * @property {REPORT_SECTION} reportSection
 * @property {WaveformIndex} representativeOnsetIndex
 * @property {WaveformIndex} representativeTerminationIndex
 * @property {String} annotation
 */
/**
 *
 * @param {AddReportEventInfoType} newAddReportInfo
 * @returns
 */
export function postReportEventRequested(newAddReportInfo) {
  return { type: POST_REPORT_EVENT_REQUESTED, newAddReportInfo };
}
function postReportEventSucceed(data) {
  return { type: POST_REPORT_EVENT_SUCCEED, data };
}
function postReportEventFailed(error) {
  return { type: POST_REPORT_EVENT_FAILED, error };
}
/**
 *
 * @param {Number} reportEventId
 * @param {AddReportEventInfoType} newAddReportInfo
 * @returns
 */
export function updateReportEventRequested(
  reportEventId,
  newAddReportInfo,
  isNotPreUpdate
) {
  return {
    type: UPDATE_REPORT_EVENT_REQUESTED,
    reportEventId,
    newAddReportInfo,
    isNotPreUpdate,
  };
}
function updateReportEventSucceed(data, isNotPreUpdate) {
  return { type: UPDATE_REPORT_EVENT_SUCCEED, data, isNotPreUpdate };
}
function updateReportEventFailed(error, isNotPreUpdate) {
  return { type: UPDATE_REPORT_EVENT_FAILED, error, isNotPreUpdate };
}
export function deleteReportEventRequested(reportEventId) {
  return { type: DELETE_REPORT_EVENT_REQUESTED, reportEventId };
}
function deleteReportEventSucceed() {
  return { type: DELETE_REPORT_EVENT_SUCCEED };
}
function deleteReportEventFailed(error) {
  return { type: DELETE_REPORT_EVENT_FAILED, error };
}

// ecg chart list edit ui interaction
export function setSelectionStripRequest(selectionStrip) {
  return { type: SET_SELECTION_STRIP, selectionStrip };
}
export function setTenSecStripRequest(tenSecStrip) {
  return { type: SET_TENSEC_STRIP, tenSecStrip };
}
export function setArrhythmiaContextmenuRequest(isOpenArrhythmiaContextmenu) {
  return { type: SET_ARRHYTHMIA_CONTEXTMENU, isOpenArrhythmiaContextmenu };
}
export function setBeatContextmenuRequest(isOpenBeatContextmenu) {
  return { type: SET_BEAT_CONTEXTMENU, isOpenBeatContextmenu };
}
export function setEcgchartlistScrollTopRequest(ecgChartListScrollTop) {
  return { type: SET_ECGCHARTLIST_SCROLL_TOP, ecgChartListScrollTop };
}

export function setTenSecStripDetailRequest(tenSecStripDetail) {
  return {
    type: SET_TENSEC_STRIP_DETAIL,
    tenSecStripDetail,
  };
}

export function setIsEcgChartListScrollRequest(isSetEcgChartListScroll) {
  return {
    type: SET_IS_ECGCHARTLIST_SCROLL_TO_INDEX,
    isSetEcgChartListScroll,
  };
}

export function postTimeEventRequested(params) {
  return { type: POST_TIME_EVENT_REQUESTED, params };
}
export function postTimeEventSucceed(data) {
  return { type: POST_TIME_EVENT_SUCCEED, data };
}
function postTimeEventFailed(error) {
  return { type: POST_TIME_EVENT_FAILED, error };
}

export function requestPrintReportRequested(tid, request) {
  return {
    type: REQUEST_PRINT_REPORT_REQUESTED,
    tid,
    request,
  };
}
function requestPrintReportSucceed(data) {
  return {
    type: REQUEST_PRINT_REPORT_SUCCEED,
    data,
  };
}
function requestPrintReportFailed(error) {
  return {
    type: REQUEST_PRINT_REPORT_FAILED,
    error,
  };
}

// Saga functions
function* _initializeState(action) {
  const isInitialized = true;
  yield put(getEcgTestRequested(isInitialized));
  // isRawData 때문에 아래 2가지 Action의 dispatch 타이밍 변경
  // TODO: 준호 - 전체 이벤트 정보 요청 타이밍 ecg test 데이터 확보 이후로 변경 필요
  // yield put(getTimeEventsListRequested()); //
  // yield put(getDailyHeartRateRequested()); //
  yield put(getTimeEventsListRequested(TIME_EVENT_TYPE.LEAD_OFF));
}

function* _selectionStripHandler(action) {
  try {
    const { selectionStrip } = action;
    const {
      selectionMarkerType,
      representativeTimestamp,
      clickedWaveformIndex,
      extraParam,
    } = selectionStrip;

    function* setEventsInfo(events) {
      const curEventInfo = yield select(
        (state) =>
          state.testResultReducer.eventReview.sidePanelState.selectedValueList
      );

      if (
        // 기존과 모두 동일한 상황
        curEventInfo.length === events.length &&
        !events.some(
          (iValue) =>
            !curEventInfo.some(
              (jValue) =>
                iValue.type === jValue.type &&
                (iValue.position === jValue.position ||
                  (iValue.timeEventId === jValue.timeEventId &&
                    iValue.waveformIndex === jValue.waveformIndex))
            )
        )
      ) {
        return;
      }

      yield put(setSidePanelSelectedValueList(events, true));
    }

    // ECG Chart List 에서 그냥 클릭이 발생된 경우
    if (selectionMarkerType === SELECTION_MARKER_TYPE.ONSET) {
      const isSelectableChart = yield select(selectIsSelectableChart);
      const isSelectableRepresentativeStrip = yield select(
        selectIsSelectableRepresentativeStrip
      );

      const { recordingStartMs } = yield select(selectRecordingTime);
      const representativeWaveformIndex = parseInt(
        (representativeTimestamp - recordingStartMs) / 4
      );
      const selectionWaveformIndex =
        representativeWaveformIndex + clickedWaveformIndex;
      const selectedMs = representativeTimestamp + clickedWaveformIndex * 4;

      if (
        // Events 텝에서 전체 이벤트 조회 가능 상황
        isSelectableChart
      ) {
        if (
          // 클릭된 지점 Noise 일 경우
          extraParam.isNoise
        ) {
          yield call(
            setEventsInfo,
            [{ type: EVENT_CONST_TYPES.NOISE, position: 0 }],
            []
          );
        } else {
          // 선택 지점의 Ectopic 정보 획득, 사전 List-Up 된 것에서 확보
          const beatEventInfo = yield select(
            ({ testResultReducer }) =>
              testResultReducer.beatsNEctopicList.data[
                representativeWaveformIndex
              ]
          );
          const ectopicInfos = (beatEventInfo?.ectopics ?? [])
            .filter(
              (value) =>
                value.onsetWaveformIndex <= selectionWaveformIndex &&
                selectionWaveformIndex <= value.terminationWaveformIndex
            )
            .map((value) => ({
              type: value.type,
              position: null,
              timeEventId: null,
              waveformIndex: value.onsetRPeakIndex,
            }));
          // 선택 지점의 Time Event 정보 획득, 사전 List-Up 된 것에서 확보
          const timeEventInfos = yield select((state) =>
            state.testResultReducer.timeEventsList.data.filter(
              (value) =>
                value.onsetMs <= selectedMs && selectedMs <= value.terminationMs
            )
          );
          const events = timeEventInfos.reduce((acc, cur) => {
            return [
              ...acc,
              {
                type: cur.type,
                position: cur.position,
                timeEventId: cur.timeEventId,
                waveformIndex: null,
              },
            ];
          }, ectopicInfos);
          yield call(
            setEventsInfo,
            events.length === 0
              ? [{ type: EVENT_CONST_TYPES.NORMAL, position: 0 }]
              : events
          );
        }
      } else if (
        // 리포트 담기 중 대표 Strip 선택 가능 상황
        isSelectableRepresentativeStrip
      ) {
        // fresh representative state update
        const fiveSecWaveformLength = (5 * 1000) / 4;
        const representativeOnsetIndex =
          selectionWaveformIndex - fiveSecWaveformLength;
        const representativeTerminationIndex =
          selectionWaveformIndex + fiveSecWaveformLength - 1;
        yield put(
          setRepresentativeStripInfo({
            selectedMs,
            representativeOnsetIndex,
            representativeTerminationIndex,
          })
        );
      } else {
        // XXX: 준호 - ???
      }
    } else if (selectionMarkerType === SELECTION_MARKER_TYPE.TERMINATION) {
      // 구간 선택 시 selectedValueList 초기화
      yield put(setSidePanelSelectedValueList([], true));
    }
  } catch (error) {
    // TODO: 준호 - 에러 발생 시 적절한(!) 예외처리 구현 필요
    console.error(error);
  }
}

function* _tenSecStripHandler(action) {
  try {
    const { tenSecStrip } = action;

    if (action?.tenSecStrip[TEN_SEC_STRIP.TYPE.RESET]) return;

    const ecgRawList = yield select(getEcgRawList);
    const beatsNEctopicList = yield select(selectBeatsNEctopicList);

    const constHr = TEN_SEC_SCRIPT_DETAIL.HR;
    const constBeatType = TEN_SEC_SCRIPT_DETAIL.BEAT_TYPE;
    const constWaveformIndex = TEN_SEC_SCRIPT_DETAIL.WAVEFORM_INDEX;

    const constMsUnitPerChartPoint = ECG_CHART_UNIT.MS_UNIT_PER_CHART_POINT;
    const constFiveSec = ECG_CHART_UNIT.FIVE_SEC;
    const constTenSec = ECG_CHART_UNIT.TEN_SEC;
    const constFiveSecWaveformIdx = ECG_CHART_UNIT.FIVE_SEC_WAVEFORM_IDX;
    const constTenSecWaveformIdx = ECG_CHART_UNIT.TEN_SEC_WAVEFORM_IDX;

    let tenSecStripDetail = {
      onsetMs: undefined,
      terminationMs: undefined,
      onsetWaveformIdx: undefined,
      terminationWaveformIdx: undefined,
      hrAvg: undefined,
      ecgRaw: [],
      beatLabelButtonDataList: [],
    };

    let tenSecStripOnsetMs,
      tenSecStripTerminationMs,
      tenSecStripOnsetWaveformIdx,
      tenSecStripTerminationWaveformIdx;

    tenSecStripOnsetMs =
      tenSecStrip.representativeCenterTimeStamp +
      tenSecStrip.centerWaveformIndex * constMsUnitPerChartPoint -
      constFiveSec;

    tenSecStripTerminationMs = tenSecStripOnsetMs + constTenSec;

    tenSecStripOnsetWaveformIdx =
      tenSecStrip.representativeCenterWaveformIndex +
      tenSecStrip.centerWaveformIndex -
      constFiveSecWaveformIdx;

    tenSecStripTerminationWaveformIdx =
      tenSecStripOnsetWaveformIdx + constTenSecWaveformIdx;

    let tenSecStripEcgRaw, filterBeatsNEctopicList;
    let filterHrList, sumHr, tenSecStripHrAvg;
    let beatLabelButtonDataList,
      beatType,
      beatColorType,
      beatTypeList,
      beatWaveformIndexList;

    // 10s strip - ecg raw data
    tenSecStripEcgRaw = _getTenSecStripEcgRaw(
      ecgRawList,
      tenSecStripOnsetWaveformIdx
    );

    if (!tenSecStripEcgRaw) {
      // [예외처리] 10s strip detail open 상태에서 event position 이동시 현재 차트리스트(raw)에 없는 시간대면 10s strip이 이동한 position의 데이터를 보여주지 못함.
      return;
    }

    // 10s strip - detail beat info
    filterBeatsNEctopicList = _getFilterBeatsNEctopicList(
      beatsNEctopicList,
      tenSecStripOnsetWaveformIdx,
      tenSecStripTerminationWaveformIdx
    );

    // 10s strip - avg hr
    filterHrList = _getTenSecStripInfo(
      filterBeatsNEctopicList,
      tenSecStripOnsetWaveformIdx,
      tenSecStripTerminationWaveformIdx,
      constHr
    );

    tenSecStripHrAvg = _getHrAvg(filterHrList);

    // 10 strip에 render 할 beat label button data
    beatLabelButtonDataList = [];
    beatType = TEN_SEC_STRIP_EDIT.BEAT_TYPE;
    beatColorType = TEN_SEC_STRIP_EDIT.BEAT_COLOR_TYPE;

    beatTypeList = _getTenSecStripInfo(
      filterBeatsNEctopicList,
      tenSecStripOnsetWaveformIdx,
      tenSecStripTerminationWaveformIdx,
      constBeatType
    );

    beatWaveformIndexList = _getTenSecStripInfo(
      filterBeatsNEctopicList,
      tenSecStripOnsetWaveformIdx,
      tenSecStripTerminationWaveformIdx,
      constWaveformIndex
    );

    for (let index in beatWaveformIndexList) {
      beatLabelButtonDataList.push({
        xAxisPoint: beatWaveformIndexList[index],
        isSelected: false,
        beatType: beatTypeList[index],
        title: beatType[beatTypeList[index]],
        color: beatColorType[beatTypeList[index]],
        isEventReview: '',
      });
    }

    tenSecStripDetail = {
      onsetMs: tenSecStripOnsetMs,
      terminationMs: tenSecStripTerminationMs,
      onsetWaveformIdx: tenSecStripOnsetWaveformIdx,
      terminationWaveformIdx: tenSecStripTerminationWaveformIdx,
      hrAvg: tenSecStripHrAvg,
      ecgRaw: tenSecStripEcgRaw,
      beatLabelButtonDataList,
    };

    yield put(setTenSecStripDetailRequest(tenSecStripDetail));

    function _getTenSecStripEcgRaw(
      ecgRawList,
      startTenSecStripWaveformIdx,
      endTenSecStripWaveformIdx = startTenSecStripWaveformIdx +
        ECG_CHART_UNIT.TEN_SEC_WAVEFORM_IDX
    ) {
      let result;
      let filterEcgRawList = [];

      filterEcgRawList = ecgRawList.filter((v, i) => {
        if (
          !(
            v.terminationWaveformIndex < startTenSecStripWaveformIdx ||
            v.onsetWaveformIndex > endTenSecStripWaveformIdx
          )
        ) {
          return v;
        }
      });

      if (filterEcgRawList.length === 1) {
        result = filterEcgRawList[0].ecgData.slice(
          startTenSecStripWaveformIdx % 7500 < 0
            ? 0
            : startTenSecStripWaveformIdx % 7500,
          (startTenSecStripWaveformIdx + 2500) % 7500 < 1250
            ? 7500
            : (startTenSecStripWaveformIdx + 2500) % 7500
        );
        // 검사 시작 부분의 tenSecStrip 검증
        if (startTenSecStripWaveformIdx % 7500 < 0) {
          result.unshift(
            ...Array.from(
              {
                length: Math.abs(startTenSecStripWaveformIdx % 7500),
              },
              () => 0
            )
          );
        }
        // 검사 제일 마지막 부분의 tenSecStrip 검증
        if ((startTenSecStripWaveformIdx + 2500) % 7500 < 1250)
          result.push(
            ...Array.from(
              {
                length: 1250,
              },
              () => 0
            )
          );
      } else if (filterEcgRawList.length === 2) {
        result = [
          ...filterEcgRawList[0].ecgData.slice(
            startTenSecStripWaveformIdx % 7500
          ),
          ...filterEcgRawList[1].ecgData.slice(
            0,
            (startTenSecStripWaveformIdx + 2500) % 7500
          ),
        ];
      }

      return result;
    }
  } catch (error) {
    console.error(error);
  }
}
/**
 * `sidePanelState.selectedValueList` 업데이트 후 배열의 길이가 1일 경우 API 를 통해 정보를 조회한다.
 *
 * 단, Normal, Noise 는 제외
 * @param {{newSelectedValueList, isFromChart}} action
 */
function* _setSelectedValueListHandler(action) {
  try {
    const { newSelectedValueList, isOnlySet } = action;
    if (isOnlySet) return;

    const sideTabValue = yield select(
      ({ testResultReducer: state }) =>
        state.eventReview.sidePanelState.tabValue
    );
    if (
      newSelectedValueList.length === 1 &&
      ![EVENT_CONST_TYPES.NORMAL, EVENT_CONST_TYPES.NOISE].includes(
        newSelectedValueList[0].type
      )
    ) {
      const newSelectedValue = newSelectedValueList[0];
      const eventId =
        newSelectedValue.timeEventId || newSelectedValue.waveformIndex;
      if (sideTabValue === EVENT_GROUP_TYPE.EVENTS) {
        //
        yield put(
          getEventDetailRequested(
            newSelectedValue.type,
            eventId,
            newSelectedValue.position,
            newSelectedValue.type !== EVENT_CONST_TYPES.PATIENT
          )
        );
      } else {
        const selectedMetaInfo = getSidePanelEventData({
          groupType: EVENT_GROUP_TYPE.REPORT,
          key: 'type',
          value: newSelectedValue.type,
        });
        yield put(
          getReportEventsRequested(
            selectedMetaInfo.reportSection,
            newSelectedValue.position
          )
        );
      }
    }
  } catch (error) {
    console.error(error);
  }
}

function* _getEcgTest(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);

    const {
      data: { result },
    } = yield call(ApiManager.readEcgTest, {
      ecgTestId,
    });

    const thirtySecMs = ECG_CHART_UNIT.TEN_SEC * 3;
    const recordingStartMs = DateUtil.formatMs(result.patchecg.startTimestamp);
    const recordingEndMs = DateUtil.formatMs(result.patchecg.endTimestamp);
    const createAt = new Date().getTime();
    yield put(
      setBasicLeadOff([
        {
          createAt,
          onsetMs: recordingStartMs - thirtySecMs,
          terminationMs: recordingStartMs,
          type: EVENT_CONST_TYPES.LEAD_OFF,
          timeEventId: `${EVENT_CONST_TYPES.LEAD_OFF}-basic-onset`,
          onsetRPeakIndex: null,
          position: -1,
        },
        {
          createAt,
          onsetMs: recordingEndMs,
          terminationMs: recordingEndMs + thirtySecMs,
          type: EVENT_CONST_TYPES.LEAD_OFF,
          timeEventId: `${EVENT_CONST_TYPES.LEAD_OFF}-basic-termination`,
          onsetRPeakIndex: null,
          position: -2,
        },
      ])
    );

    if (
      action.isInitialized &&
      !result.isRawDataOnly &&
      result.testVersion === 'v2'
    ) {
      yield put(getTimeEventsListRequested());
      yield put(getDailyHeartRateRequested());
    }
    yield put(getEcgTestSucceed(result));
  } catch (error) {
    yield put(getEcgTestFailed(error));
  }
}

/**
 * Time Event 목록 데이터 요청
 *
 * @param {*} action
 */
function* _getTimeEventsList(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const { targetTimeEventType } = action;

    const defaultParams = {
      tid: ecgTestId,
      isMinimum: true,
    };
    let timeEventGroups;
    if (targetTimeEventType) {
      const { data } = yield call(ApiManager.getTimeEventList, {
        ...defaultParams,
        eventType: targetTimeEventType,
      });
      timeEventGroups = [{ data }];
    } else {
      timeEventGroups = yield all([
        call(ApiManager.getTimeEventList, {
          ...defaultParams,
          eventType: TIME_EVENT_TYPE.AF,
        }),
        call(ApiManager.getTimeEventList, {
          ...defaultParams,
          eventType: TIME_EVENT_TYPE.PAUSE,
        }),
        call(ApiManager.getTimeEventList, {
          ...defaultParams,
          eventType: TIME_EVENT_TYPE.OTHERS,
        }),
        // call(ApiManager.getTimeEventList, {
        //   ...defaultParams,
        //   eventType: TIME_EVENT_TYPE.LEAD_OFF,
        // }),
      ]);
    }

    yield put(
      getTimeEventsListSucceed(
        targetTimeEventType,
        timeEventGroups.reduce((acc, cur) => [...acc, cur.data.results], [])
      )
    );
  } catch (error) {
    yield put(getTimeEventsListFailed(error));
    console.error(error);
  }
}

/**
 * HRV 차트에 필요한 Daily Heart Rate(dhr) 값과 Patient Trigger Events(pte) 정보 요청
 *
 * @param {*} action
 */
function* _getDailyHeartRate(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const [
      {
        data: { results: rawDhr },
      },
      {
        data: { results: pte },
      },
    ] = yield call(
      // const [dhr, pte] = yield call(
      (params) => {
        return Promise.all([
          ApiManager.getDailyHeartRate(params),
          ApiManager.getPatientTriggerEventList({
            tid: params.ecgTestId,
            ordering: 'event_timestamp',
            isMinimum: true,
          }),
        ]);
      },
      {
        ecgTestId,
      }
    );
    // HR 차트에서 사용할 데이터 셋 구성 진행
    // 1. HR 차트 Line 데이터(PTE 마크를 포함한 데이터)
    /**
     * {
     *  x: 시간,
     *  y: HR Avg,
     *  marker: {
     *   enabled: 2분 구간 동안 PTE 가 포함됐다면 true
     *  }
     * }
     */
    // 2. 전체 측정 구간에 대한 1시간 단위 밴드(+ 수면 구간 여부) 배열
    const sleeps = [];
    const patientEventTimes = [];
    const patientEvents = [];
    let sleepFrom = null;
    pte.forEach((item) => {
      if (Const.PATIENT_EVENT_TYPE.SLEEP === item.eventType) {
        sleepFrom = item.eventTimeMs;
      } else if (Const.PATIENT_EVENT_TYPE.WAKEUP === item.eventType) {
        if (sleepFrom && item.eventTimeMs - sleepFrom < 3600 * 20) {
          sleeps.push([sleepFrom, item.eventTimeMs]);
          sleepFrom = null;
        }
      } else {
        patientEventTimes.push(item.eventTimeMs);
        patientEvents.push({
          ...item,
          position: patientEvents.length + 1,
          eventTimeMs: item.eventTimeMs,
          triggerOnsetMs: item.triggerOnsetMs,
          triggerTerminationMs: item.triggerTerminationMs,
        });
      }
    });

    const aSecondMs = 1000; // 1초
    const dataPointUnitMs = 2 * 60 * aSecondMs; // 2분
    const bandLastPointMs = 58 * 60 * aSecondMs; // 3480000 = 58분 = 1시간 구간의 마지막 포인트
    const aHourMs = 60 * 60 * aSecondMs; // 1시간

    const isSleep = (fromTimestamp) =>
      sleeps.some(
        (value) =>
          fromTimestamp + aHourMs > value[0] && value[1] > fromTimestamp
      );

    // Daily Heart Rate 데이터 구성이 날자 별로 그룹핑하여 하루치 HR 데이터 배열로 제공되어 2 중 반복문이 필요
    // XXX: HRV 에서 사용하는 Daily Heart Rate 데이터 변조 로직 개선 필요?
    patientEventTimes.reverse();
    let curEventTimestamp = patientEventTimes.pop();
    /** 2. 전체 측정 구간에 대한 1시간 단위 밴드(+ 수면 구간 여부) 배열 */
    const hourlyBands = [];
    let currentBand = null;
    /** 1. HR 차트 Line 데이터(PTE 마크를 포함한 데이터) */
    const heartRatePoints = rawDhr.reduce(
      (acc, cur) =>
        acc.concat(
          cur.aggHrs.map((element) => {
            const timestamp = element.timestamp * aSecondMs;
            if (timestamp % aHourMs === 0) {
              // 구간 시작
              const _isSleep = isSleep(timestamp);
              currentBand = {
                className: `pb-huinno pb-${timestamp}${
                  _isSleep ? ' pb-huinno-sleep' : ''
                }`,
                from: timestamp,
                to: timestamp + aHourMs,
                isSleep: _isSleep,
                atTime: element.hrsAvgAvg === null ? null : timestamp,
              };
            } else {
              // 구간 내
              if (currentBand.atTime === null && element.hrsAvgAvg !== null) {
                currentBand.atTime = timestamp;
              }
              if (timestamp % aHourMs === bandLastPointMs) {
                // 구간 끝
                hourlyBands.push(currentBand);
              }
            }
            const hr = {
              x: timestamp,
              y: element.hrsAvgAvg,
            };
            while (curEventTimestamp < hr.x) {
              curEventTimestamp = patientEventTimes.pop();
            }
            if (
              hr.x <= curEventTimestamp &&
              curEventTimestamp < hr.x + dataPointUnitMs
            ) {
              hr.marker = {
                enabled: true,
              };
            }

            return hr;
          })
        ),
      []
    );
    yield put(
      getDailyHeartRateSucceed({ heartRatePoints, hourlyBands }, patientEvents)
    );
  } catch (error) {
    yield put(getDailyHeartRateFailed(error));
  }
}

/**
 * 비트 이벤트 데이터 요청
 *
 * @param {*} action
 */
function* _getBeatsNEctopicByRange(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);

    const { onsetWaveformIndex, terminationWaveformIndex } = action;
    let onsetWI = onsetWaveformIndex < 0 ? 0 : onsetWaveformIndex;

    const [
      {
        data: { result: beatsData },
      },
      {
        data: { results: onsetEctopicList },
      },
    ] = yield all([
      call(ApiManager.getBeatsFilterWaveformIndexRange, {
        ecgTestId,
        onsetWaveformIndex: onsetWI,
        terminationWaveformIndex,
      }),
      call(ApiManager.getEctopicListFilterWaveformIndexRange, {
        ecgTestId,
        onsetWaveformIndex: onsetWI,
        terminationWaveformIndex: onsetWI,
      }),
    ]);

    const leadOffList = yield select(
      ({ testResultReducer: state }) => state.timeEventsList.leadOff
    );
    const { recordingStartMs } = yield select(selectRecordingTime);
    const transformEctopicWithBeatsResult = transformEctopicWithBeats(
      beatsData,
      leadOffList,
      recordingStartMs,
      onsetEctopicList[0]
    );

    yield put(getBeatsNEctopicListSucceed(transformEctopicWithBeatsResult));
  } catch (error) {
    getBeatsNEctopicListFailed(error);
    console.error(error);
    // 에러 처리...
  }
}

function* _getEcgRaw(action) {
  try {
    const {
      atTime,
      secStep,
      isBackward,
      isForward,
      isInit,
      isJumpToTime,
      isScroll,
      withBeat = false,
      isBeatStrip = false,
    } = action;
    const formatMsAtTime = DateUtil.formatMs(
      parseInt(atTime.toString().slice(0, 9).padEnd(13, 0))
    );
    const ecgTestId = yield select(selectEcgTestId);
    const isRawDataOnly = yield select(getRawDataOnly);
    const _getTestVersion = yield select(getTestVersion);

    const {
      recordingStartMs: ecgRawRecordingStartMs,
      recordingEndMs: ecgRawRecordingEndMs,
    } = yield select(selectRecordingTime);

    let onsetMsQueryStr, terminationMsQueryStr;

    if (!isScroll) {
      onsetMsQueryStr =
        formatMsAtTime -
        (isJumpToTime ? INFINITY_SCROLL.EXPLORER_UNIT_MS.OFFSET_ROW : 0);
      terminationMsQueryStr = formatMsAtTime + secStep;

      if (ecgRawRecordingStartMs > terminationMsQueryStr) {
        throw {
          msg: 'req termination Time is before ecg Test start time',
          time: { ecgRawRecordingStartMs, terminationMsQueryStr },
          callStack: new Error(),
        };
      }
      if (terminationMsQueryStr > ecgRawRecordingEndMs) {
        terminationMsQueryStr = ecgRawRecordingEndMs;
      }
    }

    if (isScroll) {
      if (isBackward && !isForward) {
        onsetMsQueryStr = formatMsAtTime;
        terminationMsQueryStr = formatMsAtTime + secStep;

        if (ecgRawRecordingStartMs > terminationMsQueryStr) {
          throw {
            msg: 'req termination Time is before ecg Test start time',
            time: { ecgRawRecordingStartMs, terminationMsQueryStr },
            callStack: new Error(),
          };
        }
      } else if (isForward && !isBackward) {
        onsetMsQueryStr = formatMsAtTime;
        terminationMsQueryStr = formatMsAtTime + secStep;

        if (ecgRawRecordingEndMs < onsetMsQueryStr) {
          throw {
            msg: 'req onset Time is after ecg Test end time',
            time: { ecgRawRecordingStartMs, terminationMsQueryStr },
            callStack: new Error(),
          };
        }
      }
    }

    if (!isRawDataOnly && _getTestVersion === 'v2') {
      // Raw 데이터를 요청하는 구간으로 Beats + Ectopic 데이터도 요청
      yield put(
        getBeatsNEctopicListRequested(
          parseInt(Math.max(onsetMsQueryStr - ecgRawRecordingStartMs, 0) / 4),
          parseInt((terminationMsQueryStr - ecgRawRecordingStartMs) / 4)
        )
      );
    }

    DEBUGGING_LOG_ECG_RAW &&
      console.log('🚨🚨🚨 log 🚨🚨🚨 - function * _getEcgRaw', [
        onsetMsQueryStr,
        terminationMsQueryStr,
        DateUtil.formatDateTime(onsetMsQueryStr),
        DateUtil.formatDateTime(terminationMsQueryStr),
      ]);

    // # call init
    const {
      data: { results },
    } = yield call(ApiManager.getRawEcg, {
      ecgTestId,
      onsetMs: onsetMsQueryStr,
      terminationMs: terminationMsQueryStr,
      withBeat: isBeatStrip,
    });
    const newLoadedList = transformRawList(results);

    let tmpEcgRawList, newEcgRawList;
    const ecgRawList = yield select(getEcgRawList);

    // 위로 스크롤시
    if (isScroll && isBackward) {
      tmpEcgRawList = [...newLoadedList, ...ecgRawList];
    }
    // 아래로 스크롤시
    if (isScroll && isForward) {
      tmpEcgRawList = [...ecgRawList, ...newLoadedList];
    }

    newEcgRawList = tmpEcgRawList || newLoadedList;
    yield put(getEcgRawSucceed(results, action, newEcgRawList));

    // # 10s strip detail open된 케이스
    //  : select 호출 순서 중요
    const tenSecStrip = yield select(getTenSecStrip);
    if (tenSecStrip.main.representativeTimestamp) {
      const hasTenSecStrip = newLoadedList.find(
        (v) => v.onsetMs === tenSecStrip.main.representativeTimestamp
      );

      if (hasTenSecStrip) {
        yield put(setTenSecStripRequest(tenSecStrip));
      }
    }

    // # call extra init
    //  : init 전후 api call
    if (isInit) {
      let backwardOnsetMsQueryStr = onsetMsQueryStr - 1000 * 60 * 5;
      let backwardTerminationMsQueryStr = onsetMsQueryStr;
      let forwardOnsetMsQueryStr = terminationMsQueryStr;
      let forwardTerminationMsQueryStr = terminationMsQueryStr + 1000 * 60 * 5;
      let apiCallList = [];
      let initBackwardResults = [],
        initForwardResults = [];

      // reset backward Onset time, forward Termination time
      if (backwardOnsetMsQueryStr < ecgRawRecordingStartMs) {
        backwardOnsetMsQueryStr = ecgRawRecordingStartMs;
      }
      if (forwardTerminationMsQueryStr > ecgRawRecordingEndMs) {
        forwardTerminationMsQueryStr = ecgRawRecordingEndMs;
      }

      // api target list
      if (backwardTerminationMsQueryStr > ecgRawRecordingStartMs) {
        DEBUGGING_LOG_ECG_RAW &&
          console.log(
            '🚨🚨🚨 log 🚨🚨🚨 - function * _getEcgRaw > extra init',
            [
              backwardOnsetMsQueryStr,
              backwardTerminationMsQueryStr,
              DateUtil.formatDateTime(backwardOnsetMsQueryStr),
              DateUtil.formatDateTime(backwardTerminationMsQueryStr),
            ]
          );

        apiCallList.push(
          call(ApiManager.getRawEcg, {
            ecgTestId,
            onsetMs: backwardOnsetMsQueryStr,
            terminationMs: backwardTerminationMsQueryStr,
            withBeat: isBeatStrip,
          })
        );
        if (!isRawDataOnly && _getTestVersion === 'v2') {
          yield put(
            getBeatsNEctopicListRequested(
              parseInt(
                Math.max(backwardOnsetMsQueryStr - ecgRawRecordingStartMs, 0) /
                  4
              ),
              parseInt(
                (backwardTerminationMsQueryStr - ecgRawRecordingStartMs) / 4
              )
            )
          );
        }
      }
      if (forwardOnsetMsQueryStr < ecgRawRecordingEndMs) {
        DEBUGGING_LOG_ECG_RAW &&
          console.log(
            '🚨🚨🚨 log 🚨🚨🚨 - function * _getEcgRaw > extra init',
            [
              forwardOnsetMsQueryStr,
              forwardTerminationMsQueryStr,
              DateUtil.formatDateTime(forwardOnsetMsQueryStr),
              DateUtil.formatDateTime(forwardTerminationMsQueryStr),
            ]
          );

        apiCallList.push(
          call(ApiManager.getRawEcg, {
            ecgTestId,
            onsetMs: forwardOnsetMsQueryStr,
            terminationMs: forwardTerminationMsQueryStr,
            withBeat: isBeatStrip,
          })
        );
        if (!isRawDataOnly && _getTestVersion === 'v2') {
          yield put(
            getBeatsNEctopicListRequested(
              parseInt(
                Math.max(forwardOnsetMsQueryStr - ecgRawRecordingStartMs, 0) / 4
              ),
              parseInt(
                (forwardTerminationMsQueryStr - ecgRawRecordingStartMs) / 4
              )
            )
          );
        }
      }

      const apiCallListResult = yield all(apiCallList);

      for (let apiCallResult of apiCallListResult) {
        if (apiCallResult.config.params.onsetMs === backwardOnsetMsQueryStr) {
          initBackwardResults = apiCallResult.data.results;
        }
        if (apiCallResult.config.params.onsetMs === forwardOnsetMsQueryStr) {
          initForwardResults = apiCallResult.data.results;
        }
      }

      const newBackwardLoadedList = transformRawList(
        initBackwardResults,
        ecgRawRecordingStartMs
      );
      const newForwardLoadedList = transformRawList(
        initForwardResults,
        ecgRawRecordingStartMs
      );

      const newBackForwardEcgRawList = [
        ...newBackwardLoadedList,
        ...newEcgRawList,
        ...newForwardLoadedList,
      ];

      yield put(
        getEcgRawInitSucceed(
          results,
          {
            atTime: undefined,
            isBackward: true,
            isForward: false,
            isInit: true,
            isJumpToTime: false,
            isScroll: true,
            initAtTimeLocalState: action.initAtTimeLocalState,
            backwardListLength: newBackwardLoadedList.length,
            initExtraSelection: {
              backward: {
                onset: newBackwardLoadedList.at(0)?.onsetMs,
                termination: newBackwardLoadedList.at(-1)?.terminationMs,
              },
              forward: {
                onset: newForwardLoadedList.at(0)?.onsetMs,
                termination: newForwardLoadedList.at(-1)?.terminationMs,
              },
            },
          },
          newBackForwardEcgRawList
        )
      );
    }
    // # down sampling
    // for (let i = 0; i < results.length; i++) {
    //   let ecgDownSamplingArr = [];
    //   const el = results[i];
    //   for (let j = 0; j < el.ecgData.length; j++) {
    //     if (j % 2 === 1) {
    //       ecgDownSamplingArr.push(Math.max(el.ecgData[j - 1], el.ecgData[j]));
    //     }
    //   }
    //   results[i].ecgData = ecgDownSamplingArr;
    // }
  } catch (error) {
    console.error(error);
    yield put(getEcgRawFailed(error));
  }
}

function* _getEcgsStatistics() {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const {
      data: { result },
    } = yield call(ApiManager.getEcgsStatistics, ecgTestId);
    yield put(getEcgsStatisticsSucceed(result));
  } catch (error) {
    yield put(getEcgsStatisticsFailed(error));
  }
}

function* _getReportStatistics() {
  try {
    const rid = yield select(selectReportId);
    const {
      data: { result },
    } = yield call(ApiManager.getReportsStatistics, rid);
    yield put(getReportsStatisticSucceed(result));
  } catch (error) {
    yield put(getReportStatisticFailed(error));
  }
}

function* _getAllStatistics() {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const rid = yield select(selectReportId);
    const [
      {
        data: { result: ecgStatistics },
      },
      {
        data: { result: reportStatistics },
      },
    ] = yield all([
      call(ApiManager.getEcgsStatistics, ecgTestId),
      call(ApiManager.getReportsStatistics, rid),
    ]);
    const data = { ecgStatistics, reportStatistics };
    yield put(getAllStatisticsSucceed(data));
  } catch (error) {
    yield put(getAllStatisticsFailed(error));
  }
}

function* _getEventDetail(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const isUpdateFromChart = yield select(
      ({ testResultReducer: state }) =>
        state.eventReview.sidePanelState.isUpdateFromChart
    );
    const {
      eventType,
      eventId,
      position,
      isSelectedValueUpdate,
      isIgnoreTimeJump,
    } = action;
    let newSelectedValue = null;

    const eventInfo = getEventInfoByType(eventType);
    let responseData;
    if (eventType === EVENT_CONST_TYPES.PATIENT) {
      // PTE 데이터 조회, Findings 와 HR 의 최신 값 확인을 위함
      const patientEvent = yield select(({ testResultReducer: state }) =>
        state.patientEvents.find((value) => value.position === position)
      );
      if (!isUpdateFromChart && !isIgnoreTimeJump) {
        // 이벤트 조회시 onset 시점으로 ECG 차트 목록 이동
        yield put(setChartSelectedStrip(patientEvent.eventTimeMs));
      }
      const {
        data: { results },
      } = yield call(ApiManager.getPatientTriggerEventList, {
        tid: ecgTestId,
        position,
        excludeSleep: true,
      });
      responseData = results[0];
    } else if (eventInfo?.ectopicType) {
      // Ectopic 데이터 조회
      let ectopicInfo;
      const { beatType, ectopicType } = eventInfo;
      if (position) {
        // get event detail by event position
        const {
          data: { results },
        } = yield call(ApiManager.getEctopicListFilterType, {
          ecgTestId,
          beatType,
          ectopicType,
          position,
        });
        ectopicInfo = results[0];
      } else {
        // get event detail by waveformIndex
        const {
          data: { results },
        } = yield call(ApiManager.getEctopicListFilterWaveformIndex, {
          ecgTestId,
          waveformIndex: eventId,
        });
        ectopicInfo = results[0];
      }
      responseData = {
        ...ectopicInfo,
        onsetWaveformIndex: ectopicInfo.waveformIndex.at(0),
        terminationWaveformIndex: ectopicInfo.waveformIndex.at(-1),
      };
      if (!isUpdateFromChart && !isIgnoreTimeJump) {
        // 이벤트 조회시 onset 시점으로 ECG 차트 목록 이동
        const { recordingStartMs } = yield select(selectRecordingTime);
        yield put(
          setChartSelectedStrip(
            recordingStartMs + responseData.onsetWaveformIndex * 4
          )
        );
      }
      if (isSelectedValueUpdate) {
        newSelectedValue = {
          position: responseData.position,
          waveformIndex: responseData.waveformIndex[0],
        };
      }
    } else {
      // Time Event 데이터 조회
      let timeEventId;
      if (position) {
        const timeEventInfo = yield select(({ testResultReducer }) =>
          testResultReducer.timeEventsList.data.find(
            (value) => value.position === position && value.type === eventType
          )
        );
        if (!isUpdateFromChart && !isIgnoreTimeJump) {
          // 이벤트 조회시 onset 시점으로 ECG 차트 목록 이동
          yield put(setChartSelectedStrip(timeEventInfo.onsetMs));
        }
        timeEventId = timeEventInfo.timeEventId;
      } else {
        timeEventId = eventId;
      }
      const {
        data: { result },
      } = yield call(ApiManager.getTimeEventDetail, {
        timeEventId,
      });
      responseData = result;
      if (isSelectedValueUpdate) {
        newSelectedValue = {
          position: yield select(({ testResultReducer }) =>
            testResultReducer.timeEventsList.data.find(
              (value) => value.id === timeEventId
            )
          ),
          timeEventId: timeEventId,
        };
      }
    }

    // Events 텝에서 조회 시 selectedValue 가 수정될 필요 있음(position, timeEventId, waveformIndex)
    const prevSelectedValueList = yield select(
      ({ testResultReducer: state }) =>
        state.eventReview.sidePanelState.selectedValueList
    );
    const newSelectedValueList =
      prevSelectedValueList.length === 1
        ? [
            isSelectedValueUpdate
              ? {
                  type: prevSelectedValueList[0].type,
                  position:
                    newSelectedValue.position ??
                    prevSelectedValueList[0].position,
                  timeEventId:
                    newSelectedValue.timeEventId ??
                    prevSelectedValueList[0].timeEventId,
                  waveformIndex:
                    newSelectedValue.waveformIndex ??
                    prevSelectedValueList[0].waveformIndex,
                }
              : prevSelectedValueList[0],
          ]
        : prevSelectedValueList;

    yield put(getEventDetailSucceed(responseData, newSelectedValueList));
  } catch (error) {
    yield put(getEventDetailFailed(error));
  }
}

function* _getReportEvent(action) {
  try {
    const { reportSection, position } = action;
    let responseData;
    if (reportSection === REPORT_SECTION.PTE) {
      const ecgTestId = yield select(selectEcgTestId);
      const {
        data: { results },
      } = yield call(ApiManager.getPatientTriggerEventList, {
        tid: ecgTestId,
        position,
        excludeSleep: true,
        excludeNoise: true,
      });
      responseData = {
        ...results[0],
        reportSection: REPORT_SECTION.PTE,
      };
      yield put(setChartSelectedStrip(responseData.eventTimeMs));

      // Time Event 는 바로 State 업데이트
      // 기존 selectedValue 참조 필요
      const prevSelectedValueList = yield select(
        ({ testResultReducer: state }) =>
          state.eventReview.sidePanelState.selectedValueList
      );
      yield put(getEventDetailSucceed(responseData, prevSelectedValueList));

      yield put(
        setRepresentativeStripInfo({
          selectedMs: null,
          representativeOnsetIndex: responseData.triggerOnsetWaveformIndex,
          representativeTerminationIndex:
            responseData.triggerTerminationWaveformIndex,
        })
      );
    } else {
      const rid = yield select(selectReportId);
      const {
        data: { results },
      } = yield call(ApiManager.getReportEvents, {
        rid,
        reportSection,
        position,
      });
      responseData = results[0];
      const { representativeOnsetIndex, representativeTerminationIndex } =
        responseData;
      const selectedTimeWaveformIndex =
        reportSection === REPORT_SECTION.ADDITIONAL
          ? representativeOnsetIndex
          : representativeOnsetIndex +
            Math.floor(
              (representativeTerminationIndex - representativeOnsetIndex) / 2
            );
      const { recordingStartMs } = yield select(selectRecordingTime);
      yield put(
        setChartSelectedStrip(recordingStartMs + selectedTimeWaveformIndex * 4)
      );

      const { timeEvent: timeEventDetail } = responseData;
      if (timeEventDetail?.ectopicType) {
        const ectopicEventType = getEventInfoByQuery({
          beatType: BEAT_TYPE[timeEventDetail.eventType],
          ectopicType: timeEventDetail.ectopicType,
        }).type;
        yield put(
          getEventDetailRequested(
            ectopicEventType,
            timeEventDetail.onsetWaveformIndex,
            null,
            false,
            true
          )
        );
      } else {
        // Time Event 는 바로 State 업데이트
        // 기존 selectedValue 참조 필요
        const prevSelectedValueList = yield select(
          ({ testResultReducer: state }) =>
            state.eventReview.sidePanelState.selectedValueList
        );

        yield put(
          getEventDetailSucceed(timeEventDetail, prevSelectedValueList)
        );
      }
      yield put(
        setRepresentativeStripInfo(getInitRepresentativeStripInfo(responseData))
      );
    }

    yield put(getReportEventsSucceed(responseData));
  } catch (error) {
    yield put(getReportEventsFailed(error));
  }
}

function* _postReportEvent(action) {
  try {
    const { newAddReportInfo } = action;
    const param = { ...newAddReportInfo };
    if (!param['timeEventId']) delete param['timeEventId'];
    if (!param['onsetWaveformIndex']) delete param['onsetWaveformIndex'];
    const {
      data: { result },
    } = yield call(ApiManager.postReportEvents, param);
    yield put(postReportEventSucceed(result));
  } catch (error) {
    yield put(postReportEventFailed(error));
  }
}

function* _updateReportEvent(action) {
  try {
    const { reportEventId, newAddReportInfo } = action;
    yield call(ApiManager.updateReportEvents, {
      reportEventId,
      ...newAddReportInfo,
    });
    yield put(updateReportEventSucceed({}, action.isNotPreUpdate));
  } catch (error) {
    yield put(updateReportEventFailed(error, action.isNotPreUpdate));
  }
}

function* _deleteReportEvent(action) {
  try {
    const { reportEventId } = action;

    yield call(ApiManager.deleteReportEvents, { reportEventId });
    yield put(deleteReportEventSucceed());
  } catch (error) {
    yield put(deleteReportEventFailed(error));
  }
}

function* _postBeats(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const {
      reqBody,
      onsetWaveformIndex,
      terminationWaveformIndex,
      suffix,
      tabType,
    } = action;

    const { data } = yield call(
      ApiManager.postBeats,
      ecgTestId,
      suffix,
      reqBody
    );

    yield put(postBeatsSucceed(data));

    if (tabType === TEN_SEC_STRIP_DETAIL.TAB.EVENT_REVIEW) {
      const { searchOnsetRequest, searchTerminationRequest } =
        getSearchBeatsNEctopicListRangeAfterUpdateEvent(
          onsetWaveformIndex,
          terminationWaveformIndex
        );

      yield put(
        getBeatsNEctopicListRequested(
          searchOnsetRequest,
          searchTerminationRequest
        )
      );
      // beat 편집 => 업데이트 후 sidePanel 상태 업데이트를 위해 statistics 호출
      yield put(getEcgsStatisticsRequest());
    }
  } catch (error) {
    yield put(postBeatsFailed(error, action));
  }
}

function* _patchBeats(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const {
      reqBody,
      onsetWaveformIndex,
      terminationWaveformIndex,
      suffix,
      tabType,
    } = action;

    const { data, status } = yield call(
      ApiManager.patchBeats,
      ecgTestId,
      suffix,
      reqBody
    );
    yield put(patchBeatsSucceed(data, tabType));

    if (
      action.tabType === TEN_SEC_STRIP_DETAIL.TAB.EVENT_REVIEW ||
      action.tabType === TEN_SEC_STRIP_DETAIL.TAB.ARRHYTHMIA_CONTEXTMENU
    ) {
      const { searchOnsetRequest, searchTerminationRequest } =
        getSearchBeatsNEctopicListRangeAfterUpdateEvent(
          onsetWaveformIndex,
          terminationWaveformIndex
        );
      yield put(
        getBeatsNEctopicListRequested(
          searchOnsetRequest,
          searchTerminationRequest
        )
      );
      yield put(getEcgsStatisticsRequest());
    }
  } catch (error) {
    console.error(error);
    yield put(patchBeatsFailed(error, action));
  }
}

function* _deleteBeats(action) {
  try {
    const ecgTestId = yield select(selectEcgTestId);
    const {
      reqBody,
      onsetWaveformIndex,
      terminationWaveformIndex,
      suffix,
      tabType,
    } = action;

    const { data, status } = yield call(
      ApiManager.deleteBeats,
      ecgTestId,
      suffix,
      reqBody
    );

    if (status === 204) {
      yield put(deleteBeatsSucceed(reqBody));
    }

    if (tabType === TEN_SEC_STRIP_DETAIL.TAB.EVENT_REVIEW) {
      const { searchOnsetRequest, searchTerminationRequest } =
        getSearchBeatsNEctopicListRangeAfterUpdateEvent(
          onsetWaveformIndex,
          terminationWaveformIndex
        );
      yield put(
        getBeatsNEctopicListRequested(
          searchOnsetRequest,
          searchTerminationRequest
        )
      );
      yield put(getEcgsStatisticsRequest());
    }
  } catch (error) {
    yield put(deleteBeatsFailed(error, action));
  }
}

function* _requestPrintReport(action) {
  try {
    const { data } = yield call(ApiManager.requestPrintReport, {
      tid: action.tid,
      ...action.request,
    });
    const { error, result } = data;

    yield put(requestPrintReportSucceed(result));
    return;
  } catch (error) {
    yield put(requestPrintReportFailed(error));
  }
}

function* _postTimeEvent(action) {
  const { params } = action;
  try {
    const { data } = yield call(ApiManager.postTimeEvent, params);
    yield put(postTimeEventSucceed(data.result));
    yield put(getTimeEventsListRequested(params.eventType));
    yield put(getEcgsStatisticsRequest());
  } catch (error) {
    yield put(postTimeEventFailed(error));
  }
}

// Saga
export function* saga() {
  /* 
    :: TAB :: event review (ECG chart list)
    :: TAB :: event review (Arrhythmia Edit visualize)
    :: TAB :: event review (side panel)
    :: 10s strip detail - beat edit ::
  */

  // :: TAB :: event review (ECG chart list)
  yield takeLatest(INITIALIZE, _initializeState);
  yield debounce(200, GET_ECG_TEST_REQUESTED, _getEcgTest);
  yield takeLatest(GET_DAILY_HEART_RATE_REQUESTED, _getDailyHeartRate);
  yield takeLatest(GET_ECGRAW_INIT_REQUESTED, _getEcgRaw);
  yield takeLatest(GET_ECGRAW_REQUESTED, _getEcgRaw);
  yield takeLatest(GET_ECGRAW_BACKWARD_REQUESTED, _getEcgRaw);
  yield takeLatest(GET_ECGRAW_FORWARD_REQUESTED, _getEcgRaw);
  yield takeLatest(SET_SELECTION_STRIP, _selectionStripHandler);
  yield takeLatest(SET_TENSEC_STRIP, _tenSecStripHandler);
  yield takeLatest(
    SET_SIDE_PANEL_SELECTED_VALUE_LIST,
    _setSelectedValueListHandler
  );

  // :: TAB :: event review (Arrhythmia Edit visualize)
  yield takeEvery(GET_TIME_EVENTS_LIST_REQUESTED, _getTimeEventsList);
  yield takeEvery(GET_BEATS_N_ECTOPIC_LIST_REQUESTED, _getBeatsNEctopicByRange);

  // :: TAB :: event review (side panel)
  yield takeLatest(GET_ALL_STATISTICS_REQUESTED, _getAllStatistics);
  yield takeLatest(GET_ECGS_STATISTICS_REQUESTED, _getEcgsStatistics);
  yield takeLatest(GET_REPORTS_STATISTICS_REQUESTED, _getReportStatistics);
  yield takeLatest(GET_EVENT_DETAIL_REQUESTED, _getEventDetail);
  yield takeLatest(GET_REPORT_EVENTS_REQUESTED, _getReportEvent);
  yield takeLatest(POST_REPORT_EVENT_REQUESTED, _postReportEvent);
  yield takeLatest(UPDATE_REPORT_EVENT_REQUESTED, _updateReportEvent);
  yield takeLatest(DELETE_REPORT_EVENT_REQUESTED, _deleteReportEvent);

  // :: 10s strip detail - beat edit::
  yield takeEvery(POST_BEATS_REQUESTED, _postBeats); // create beat
  yield takeEvery(PATCH_BEATS_REQUESTED, _patchBeats); // modify beat
  yield takeEvery(DELETE_BEATS_REQUESTED, _deleteBeats); // delete beat
  yield takeEvery(POST_TIME_EVENT_REQUESTED, _postTimeEvent); // selection strip

  // :: Report 생성
  yield takeLatest(REQUEST_PRINT_REPORT_REQUESTED, _requestPrintReport);
}
